import { createContext, useContext, useEffect, useState } from "react";

const dict = {
  fr: {
    // ===== Header =====
    "header.search": "Rechercher un produit, un service, un vendeur…",
    "header.search.short": "Rechercher…",
    "header.products": "Produits",
    "header.services": "Services",
    "header.categories": "Catégories",
    "header.login": "Se connecter",
    "header.register": "S'inscrire",
    "header.profile": "Mon profil",
    "header.favorites": "Mes favoris",
    "header.orders": "Mes commandes",
    "header.notifications": "Notifications",
    "header.seller_dashboard": "Tableau vendeur",
    "header.admin": "Administration",
    "header.logout": "Déconnexion",
    "header.country_currency": "Pays & devise",
    "header.language": "Langue",

    // ===== Home =====
    "home.tag": "PLACE DE MARCHÉ",
    "home.title.buy": "Achetez, vendez, offrez vos",
    "home.title.services": "services",
    "home.title.dash": "— tout au même endroit.",
    "home.subtitle": "SUKANACOOP est la place de marché qui met en relation acheteurs, vendeurs et prestataires de services, dans un environnement moderne et sécurisé.",
    "home.cta.products": "Explorer les produits",
    "home.cta.providers": "Trouver un prestataire",
    "home.badge.payment": "Paiement sécurisé",
    "home.badge.delivery": "Retrait & livraison",
    "home.badge.community": "Communauté active",
    "home.explore": "Explorer",
    "home.all_categories": "Toutes les catégories",
    "home.see_all": "Voir tout",
    "home.new_badge": "Nouveau",
    "home.open_shop_title": "Ouvrez votre boutique en 5 minutes",
    "home.open_shop_desc": "Publiez vos produits ou vos services, gérez commandes et messages depuis un tableau de bord clair.",
    "home.become_seller": "Devenir vendeur",
    // ===== Seller Landing =====
    "home.sellers_landing.eyebrow": "VENDEURS · FRANCE 🇫🇷 · RDC 🇨🇩",
    "home.sellers_landing.title": "Ouvrez votre boutique en 5 minutes",
    "home.sellers_landing.subtitle": "Rejoignez la marketplace qui connecte la diaspora congolaise à la France. Publiez, vendez, encaissez sans compte marchand — nous nous chargeons de tout.",
    "home.sellers_landing.launch_offer": "3 mois gratuits sur Standard & Pro — Offre de lancement",
    "home.sellers_landing.benefit.visibility.title": "Visibilité immédiate",
    "home.sellers_landing.benefit.visibility.desc": "Vos annonces sont référencées dans nos catégories, notre moteur de recherche et notre répertoire de boutiques dès la publication.",
    "home.sellers_landing.benefit.commission.title": "Commission juste — 7 à 10%",
    "home.sellers_landing.benefit.commission.desc": "Aucun frais d'inscription. Vous ne payez que quand vous vendez. Commission dégressive à mesure que vous montez en gamme.",
    "home.sellers_landing.benefit.logistics.title": "Logistique clé en main",
    "home.sellers_landing.benefit.logistics.desc": "4 options de livraison intégrées : retrait, Kinshasa, inter-provinces RDC, international. Le client paye la livraison en même temps que la commande.",
    "home.sellers_landing.benefit.instant_pay.title": "Reversement Mobile Money",
    "home.sellers_landing.benefit.instant_pay.desc": "Recevez votre argent directement sur votre compte Vodacom, Airtel ou Orange Money après la période de sécurité — automatique.",
    "home.sellers_landing.plans_eyebrow": "3 FORMULES",
    "home.sellers_landing.plans_title": "Choisissez la formule adaptée à votre activité",
    "home.sellers_landing.see_all_plans": "Voir toutes les formules",
    "home.sellers_landing.month": "mois",
    "home.sellers_landing.plan.free.name": "Gratuit",
    "home.sellers_landing.plan.free.tagline": "5 annonces · Commission 10% · Découvrir la plateforme",
    "home.sellers_landing.plan.standard.name": "Standard",
    "home.sellers_landing.plan.standard.tagline": "50 annonces · Commission 10% · Badge Vendeur Actif · 3 mois gratuits",
    "home.sellers_landing.plan.pro.name": "Pro",
    "home.sellers_landing.plan.pro.tagline": "Illimité · Commission 7% · Boost SEO · Analytics · 3 mois gratuits",
    "home.sellers_landing.cta_hint": "Créez votre compte vendeur en moins de 5 minutes. Aucune carte bancaire requise pour démarrer.",
    "home.sellers_landing.cta_signup": "🚀 Créer ma boutique gratuitement",
    "home.sellers_landing.cta_see_shops": "Voir les boutiques existantes",
    "home.launch.badge": "🎉 LANCEMENT",
    "home.launch.text": "Profitez de",
    "home.launch.code": "LANCEMENT10",
    "home.launch.discount": "pour -10% sur votre première commande",
    "home.launch.cta": "Explorer les offres",
    "home.launch.copy": "Copier le code",
    "home.launch.copied": "Code copié !",
    "home.new_arrivals.eyebrow": "✨ Fraîchement arrivé",
    "home.new_arrivals.title": "Nouveautés SUKANACOOP",
    "home.new_arrivals.subtitle": "Les derniers produits et services ajoutés sur la marketplace.",
    "home.new_arrivals.see_all": "Voir tout",
    "home.featured": "En vedette",
    "home.featured_products": "Produits mis en avant",
    "home.all_products": "Tous les produits",
    "home.highlight": "À la une",
    "home.featured_services": "Services proposés",
    "home.all_services": "Tous les services",
    "home.cat.service": "Service",
    "home.cat.mixed": "Mixte",
    "home.cat.product": "Produit",

    // ===== Common =====
    "common.loading": "Chargement…",
    "common.save": "Enregistrer",
    "common.saving": "Enregistrement…",
    "common.cancel": "Annuler",
    "common.delete": "Supprimer",
    "common.edit": "Modifier",
    "common.apply": "Appliquer",
    "common.total": "Total",
    "common.subtotal": "Sous-total",
    "common.results": "résultat(s)",
    "common.explore": "Explorer",
    "common.all": "Toutes",
    "common.back": "Retour",
    "common.next": "Continuer",
    "common.previous": "Précédent",
    "common.send": "Envoyer",
    "common.error": "Erreur",
    "common.create": "Créer",
    "common.creating": "Création…",
    "common.optional": "facultatif",
    "common.required": "obligatoire",
    "common.copy": "Copier",
    "common.copied": "Copié",
    "common.view": "Voir",
    "common.sending": "Envoi…",
    "common.close": "Fermer",
    "common.yes": "Oui",
    "common.no": "Non",
    "common.confirm": "Confirmer",

    // ===== Cart =====
    "cart.title": "Mon panier",
    "cart.empty": "Votre panier est vide.",
    "cart.summary": "Récapitulatif",
    "cart.coupon.label": "Code promo",
    "cart.coupon.placeholder": "Ex : BIENVENUE10",
    "cart.payment": "Méthode de paiement",
    "cart.pay.mobile": "Mobile Money",
    "cart.pay.wallet_currency": "Devise du portefeuille Mobile Money",
    "cart.pay.wallet_currency_hint": "Choisissez la devise du portefeuille depuis lequel PawaPay va débiter. Sur Vodacom / Airtel / Orange RDC, votre compte peut contenir des USD et/ou des CDF — sélectionnez le portefeuille où vous avez du solde.",
    "cart.pay.debit_in": "Prélèvement en",
    "cart.pay.bank": "Virement bancaire",
    "cart.pay.bank.badge": "GROS MONTANTS",
    "cart.delivery": "Mode de remise",
    "cart.delivery.pickup": "Retrait sur place",
    "cart.delivery.local": "Livraison locale",
    "cart.delivery.address": "Adresse",
    "cart.delivery.address_placeholder": "Numéro, rue, ville, quartier…",
    "cart.shipping_title": "Livraison",
    "cart.shipping_line": "Livraison",
    "cart.shipping_free": "Gratuit",
    "cart.checkout.pawapay": "Payer via Mobile Money",
    "cart.checkout.bank": "Créer commande & voir instructions",
    "cart.terms.pre": "J'ai lu et j'accepte les",
    "cart.terms.link": "Conditions Générales de Vente & Politique de remboursement",
    "cart.terms.post": "de SUKANACOOP.",
    "cart.terms.error": "Merci d'accepter les CGV avant de finaliser votre commande.",
    "cart.clear": "Vider le panier",

    // ===== Listings =====
    "listing.products.title": "Produits",
    "listing.services.title": "Services",
    "listing.filter.search": "Recherche",
    "listing.filter.category": "Catégorie",
    "listing.filter.priceMin": "Prix min",
    "listing.filter.priceMax": "Prix max",
    "listing.filter.city": "Ville",
    "listing.tab.congo": "Congo (RDC)",
    "listing.tab.france": "France",
    "listing.filter.keyword": "Mot-clé…",

    // ===== Favorites =====
    "fav.title": "Mes favoris",
    "fav.guest.title": "Vos coups de cœur",
    "fav.guest.subtitle": "Connectez-vous pour retrouver vos produits et services favoris.",
    "fav.empty": "Aucun favori pour l'instant.",
    "fav.empty.hint": "Cliquez sur le cœur ❤️ des produits que vous aimez pour les retrouver ici.",
    "fav.explore": "Explorer les produits",
    "fav.section.products": "Produits",
    "fav.section.services": "Services",
    "fav.added": "Ajouté aux favoris ❤️",
    "fav.removed": "Retiré des favoris",
    "fav.login_needed": "Connectez-vous pour ajouter aux favoris",

    // ===== Footer =====
    "footer.marketplace": "Marketplace",
    "footer.sell": "Vendre",
    "footer.help_legal": "Aide & Légal",
    "footer.description": "La place de marché pour produits & services, connectant acheteurs, vendeurs et prestataires à travers le monde.",
    "footer.becomeSeller": "Devenir vendeur",
    "footer.dashboard": "Tableau de bord",
    "footer.legal": "Mentions légales",
    "footer.search": "Recherche",

    // ===== Login =====
    "login.title": "Se connecter",
    "login.subtitle": "Ravi de vous revoir sur SUKANACOOP.",
    "login.email": "Email",
    "login.password": "Mot de passe",
    "login.forgot": "Mot de passe oublié ?",
    "login.submit": "Se connecter",
    "login.no_account": "Pas de compte ?",
    "login.register": "S'inscrire",
    "login.loading": "Connexion…",
    "login.error": "Identifiants invalides",

    // ===== Register (choice) =====
    "reg.tag": "SUKANACOOP",
    "reg.title": "Rejoignez la communauté",
    "reg.subtitle": "Comment souhaitez-vous utiliser SUKANACOOP ? Choisissez votre profil pour commencer.",
    "reg.buyer_title": "Je suis Acheteur",
    "reg.buyer_desc": "Je veux acheter des produits ou réserver des services proposés par les vendeurs SUKANACOOP.",
    "reg.buyer_b1": "Inscription gratuite en 1 minute",
    "reg.buyer_b2": "Paiement sécurisé (Mobile Money & carte)",
    "reg.buyer_b3": "Favoris, commandes et messagerie",
    "reg.buyer_cta": "S'inscrire comme Acheteur",
    "reg.seller_title": "Je suis Vendeur / Prestataire",
    "reg.seller_desc": "J'ai une boutique, je suis artisan, ou je propose un service. Je veux vendre sur SUKANACOOP.",
    "reg.seller_b1": "Ouvrez votre boutique en ligne",
    "reg.seller_b2": "Recevez vos paiements en Mobile Money",
    "reg.seller_b3": "Vérification sécurisée du compte (KYC)",
    "reg.seller_cta": "Devenir Vendeur",
    "reg.earn_badge": "GAGNEZ DE L'ARGENT",
    "reg.already": "Déjà inscrit ?",
    "reg.back": "Retour au choix",

    // ===== Buyer form =====
    "reg.b.title": "Inscription Acheteur",
    "reg.b.subtitle": "Créez votre compte en 30 secondes.",
    "reg.b.fullname": "Nom complet",
    "reg.b.email": "Email",
    "reg.b.password": "Mot de passe (min. 6 caractères)",
    "reg.b.city": "Ville",
    "reg.b.country": "Pays",
    "reg.b.submit": "Créer mon compte acheteur",
    "reg.b.loading": "Création…",
    "reg.b.terms": "En vous inscrivant, vous acceptez nos",
    "reg.b.terms_link": "CGV",

    // ===== Legacy Register =====
    "reg.legacy.title": "Créer un compte",
    "reg.legacy.subtitle": "Rejoignez la communauté SUKANACOOP",
    "reg.legacy.iam": "Je suis",
    "reg.legacy.buyer": "Acheteur",
    "reg.legacy.buyer_desc": "Explorer et acheter",
    "reg.legacy.seller": "Vendeur / Prestataire",
    "reg.legacy.seller_desc": "Ouvrir une boutique",
    "reg.legacy.fullname": "Nom complet",
    "reg.legacy.email": "Email",
    "reg.legacy.password": "Mot de passe",
    "reg.legacy.city": "Ville",
    "reg.legacy.country": "Pays",
    "reg.legacy.submit": "Créer mon compte",
    "reg.legacy.loading": "Création…",
    "reg.legacy.success": "Compte créé ! Un email de vérification a été envoyé (mock).",
    "reg.legacy.error": "Erreur d'inscription",

    // ===== Seller Register wizard =====
    "rs.title": "Devenir Vendeur",
    "rs.step_of": "Étape {step} sur {total}",
    "rs.step1_label": "Étape 1 · Votre compte",
    "rs.step2_label": "Étape 2 · Votre boutique",
    "rs.step3_label": "Étape 3 · Informations légales entreprise",
    "rs.account_type": "Type de compte *",
    "rs.individual": "Particulier / Artisan (personne physique)",
    "rs.business": "Entreprise enregistrée (RCCM)",
    "rs.change_later": "Vous pourrez modifier plus tard si votre statut évolue.",
    "rs.responsible_fullname": "Nom complet du responsable *",
    "rs.responsible_placeholder": "Prénom Nom",
    "rs.email": "Email *",
    "rs.email_placeholder": "vous@boutique.com",
    "rs.phone": "Téléphone *",
    "rs.phone_placeholder": "+243 ...",
    "rs.password_min": "Mot de passe * (min. 6 caractères)",
    "rs.shop_name": "Nom de votre boutique *",
    "rs.shop_name_placeholder": "Ex : Miel du Katanga",
    "rs.shop_name_hint": "Ce nom sera visible par les acheteurs.",
    "rs.city": "Ville *",
    "rs.country": "Pays *",
    "rs.address_recommend": "Adresse (recommandé)",
    "rs.address_placeholder": "Numéro, avenue, commune…",
    "rs.what_sell": "Que vendez-vous ? (description libre)",
    "rs.what_sell_placeholder": "Ex : Miel artisanal, textiles Wax, cours particuliers…",
    "rs.business_name": "Nom légal de l'entreprise *",
    "rs.business_name_placeholder": "Nom tel qu'inscrit au RCCM",
    "rs.rccm": "Numéro RCCM *",
    "rs.rccm_placeholder": "CD/KIN/RCCM/24-B-...",
    "rs.tax_id": "Numéro Impôt (NIF)",
    "rs.confirmation": "Confirmation & conditions",
    "rs.kyc_notice_before": "Après inscription, vous devrez compléter la",
    "rs.kyc_notice_strong": "vérification KYC",
    "rs.kyc_notice_after": "(pièce d'identité, selfie) pour publier plus de 3 annonces.",
    "rs.commission_notice_before": "SUKANACOOP prélève",
    "rs.commission_notice_strong": "10% de commission",
    "rs.commission_notice_after": "sur chaque vente et reverse le solde après 5 jours (délai de rétention).",
    "rs.accept_terms_pre": "J'accepte les",
    "rs.terms_link": "Conditions Générales de Vente",
    "rs.accept_terms_post": "et la politique de confidentialité.",
    "rs.accept_commission": "J'accepte la commission SUKANACOOP de 10% et le délai de rétention de 5 jours.",
    "rs.previous": "Précédent",
    "rs.continue": "Continuer",
    "rs.create_shop": "Créer ma boutique",
    "rs.creating": "Création…",
    "rs.err_fill_all": "Remplissez tous les champs obligatoires",
    "rs.err_password_min": "Mot de passe min. 6 caractères",
    "rs.err_terms": "Vous devez accepter les conditions.",
    "rs.err_business": "Nom de l'entreprise + RCCM obligatoires pour une entreprise",
    "rs.success": "Compte vendeur créé ! Complétez votre vérification KYC pour commencer à vendre.",
    "rs.err_signup": "Erreur d'inscription",
    "rs.already": "Déjà inscrit ?",
    "rs.login": "Se connecter",

    // ===== ItemDetail =====
    "item.stock": "En stock",
    "item.out_of_stock": "Rupture de stock",
    "item.add_to_cart": "Ajouter au panier",
    "item.buy_now": "Acheter",
    "item.description": "Description",
    "item.reviews": "Avis",
    "item.no_reviews": "Aucun avis pour l'instant.",
    "item.write_review": "Écrire un avis",
    "item.publish_review": "Publier",
    "item.rate_label": "Note",
    "item.review_placeholder": "Votre avis…",
    "item.seller": "Vendeur",
    "item.location": "Localisation",
    "item.contact_seller": "Contacter le vendeur",
    "item.quantity": "Quantité",
    "item.category": "Catégorie",
    "item.added_to_cart": "Ajouté au panier",
    "item.product": "Produit",
    "item.service": "Service",
    "item.new_no_reviews": "Nouveau",
    "item.stock_line": "Stock :",
    "item.stock_available": "disponibles",
    "item.stock_out_text": "épuisé",
    "item.service_quote": "Prestation sur devis / à réserver",
    "item.pay_secure": "🔒 Paiement 100% sécurisé",
    "item.pay_mm_card": "Mobile Money · Carte",
    "item.rate_note": "Note :",
    "item.msg_placeholder": "Envoyer un message au vendeur…",
    "item.msg_send": "Envoyer",
    "item.msg_login_required": "Connectez-vous",
    "item.review_login_required": "Connectez-vous pour laisser un avis",
    "item.review_published": "Avis publié",
    "item.msg_sent": "Message envoyé",
    "item.err": "Erreur",
    "item.book_title": "Réserver un créneau",
    "item.book_pick": "Choisissez un créneau disponible :",
    "item.book_no_slots": "Aucun créneau disponible pour l'instant. Contactez le prestataire.",
    "item.book_phone": "Votre téléphone (optionnel)",
    "item.book_notes": "Notes ou demandes particulières (optionnel)",
    "item.book_confirm": "Confirmer la réservation",
    "item.book_success": "Réservation envoyée — le prestataire vous contactera",
    "item.book_login_required": "Connectez-vous pour réserver",
    "item.book_pick_slot": "Sélectionnez un créneau d'abord",
    "item.book_note": "Le prestataire vous contactera pour confirmer et convenir du paiement.",

    // ===== Search =====
    "search.title": "Résultats de recherche",
    "search.no_results": "Aucun résultat pour votre recherche.",
    "search.for": "pour",

    // ===== Categories page =====
    "categories.title": "Toutes les catégories",
    "categories.subtitle": "Explorez par produit, par service ou par pays",

    // ===== Profile =====
    "profile.title": "Mon profil",
    "profile.name": "Nom",
    "profile.email": "Email",
    "profile.phone": "Téléphone",
    "profile.city": "Ville",
    "profile.country": "Pays",
    "profile.save": "Enregistrer",
    "profile.password_section": "Sécurité — mot de passe",
    "profile.old_password": "Ancien mot de passe",
    "profile.new_password": "Nouveau mot de passe",
    "profile.confirm_password": "Confirmer",
    "profile.change_password": "Changer le mot de passe",
    "profile.saved": "Profil mis à jour",
    "profile.pw_changed": "Mot de passe modifié",
    "profile.newsletter_title": "Communications SUKANACOOP",
    "profile.newsletter_active": "Vous recevez nos nouveautés, arrivages et promotions par email.",
    "profile.newsletter_inactive": "Recevez en avant-première nos nouveaux produits, arrivages et offres exclusives.",
    "profile.newsletter_subscribe": "M'abonner aux nouveautés",
    "profile.newsletter_unsubscribe": "Se désabonner",
    "profile.newsletter_on": "Vous recevrez les nouveautés SUKANACOOP ✨",
    "profile.newsletter_off": "Vous ne recevrez plus les nouveautés",
    "reg.newsletter": "Je souhaite recevoir les nouveautés, arrivages, promotions et offres de SUKANACOOP par email. Je peux me désabonner à tout moment depuis mon compte.",

    // ===== Orders =====
    "orders.title": "Mes commandes",
    "orders.empty": "Vous n'avez pas encore de commande.",
    "orders.reference": "Référence",
    "orders.date": "Date",
    "orders.total": "Total",
    "orders.status": "Statut",
    "orders.details": "Détails",
    "orders.payment": "Paiement",
    "orders.paid": "Payé",
    "orders.pending": "En attente",
    "orders.confirmed": "Confirmée",
    "orders.shipped": "Expédiée",
    "orders.delivered": "Livrée",
    "orders.cancelled": "Annulée",
    "orders.invoice": "Facture PDF",
    "orders.awaiting_transfer": "En attente de virement",

    // ===== Refunds (buyer) =====
    "refund.request_cta": "Demander un remboursement",
    "refund.badge_pending": "Remboursement en cours d'examen",
    "refund.badge_approved": "Remboursement approuvé",
    "refund.badge_rejected": "Demande de remboursement refusée",
    "refund.approved_hint": "en cours de virement — vous recevrez un email dès l'exécution.",
    "refund.rejected_reason": "Motif :",
    "refund.window_expired": "Le délai de rétractation ({days} jours) est dépassé.",
    "refund.modal_title": "Demander un remboursement",
    "refund.modal_intro": "Précisez le motif — notre équipe traite votre demande sous 2 à 5 jours ouvrés. Le remboursement sera effectué via le même canal que le paiement d'origine.",
    "refund.reason_label": "Motif *",
    "refund.reason_placeholder": "Choisir un motif…",
    "refund.reason_defective": "Produit défectueux",
    "refund.reason_not_as_described": "Produit non conforme à la description",
    "refund.reason_not_delivered": "Commande non livrée",
    "refund.reason_missing_item": "Produit manquant",
    "refund.reason_other": "Autre",
    "refund.comment_label": "Commentaire",
    "refund.comment_label_required": "Précisez le motif *",
    "refund.comment_placeholder": "Détaillez le problème rencontré…",
    "refund.payout_label": "Coordonnées de remboursement (facultatif)",
    "refund.payout_placeholder": "IBAN, numéro Mobile Money ou compte PayPal si différent du paiement d'origine",
    "refund.payout_hint": "Par défaut, nous remboursons via le même canal que votre paiement.",
    "refund.submit": "Envoyer ma demande",
    "refund.submitting": "Envoi…",
    "refund.submit_success": "Demande envoyée — vous recevrez un email de confirmation.",
    "refund.err_reason": "Merci de choisir un motif.",
    "refund.err_other_comment": "Merci de préciser votre motif dans le commentaire.",
    "refund.cancel": "Annuler",
    "refund.modal_close": "Fermer",

    // ===== KYC / SellerVerification =====
    "kyc.back": "← Retour au tableau de bord",
    "kyc.title": "Vérification KYC vendeur",
    "kyc.intro": "Cette vérification protège les acheteurs et renforce la confiance dans votre boutique. Vos documents sont stockés de façon confidentielle et ne seront jamais publiés.",
    "kyc.pending_title": "Vérification en cours",
    "kyc.pending_desc": "Un administrateur examine actuellement vos documents. Vous recevrez une notification dès la fin.",
    "kyc.verified_title": "Compte vérifié ✓",
    "kyc.verified_desc": "Vous pouvez publier sans limite et recevoir vos paiements.",
    "kyc.rejected_title": "Vérification refusée",
    "kyc.rejected_reason": "Motif :",
    "kyc.rejected_fix": "Corrigez les informations ci-dessous puis soumettez à nouveau.",
    "kyc.section1": "1. Identité du vendeur",
    "kyc.section2": "2. Adresse & Localisation",
    "kyc.section_business": "3. Informations entreprise",
    "kyc.section_docs_biz": "4. Documents justificatifs",
    "kyc.section_docs_ind": "3. Documents justificatifs",
    "kyc.section_payout_biz": "5. Compte de réception",
    "kyc.section_payout_ind": "4. Compte de réception",
    "kyc.seller_type": "Type de vendeur *",
    "kyc.individual": "Particulier",
    "kyc.business": "Entreprise enregistrée",
    "kyc.full_legal_name": "Nom légal complet *",
    "kyc.full_legal_placeholder": "Comme sur la pièce d'identité",
    "kyc.dob": "Date de naissance *",
    "kyc.phone": "Téléphone (vérifiable) *",
    "kyc.phone_placeholder": "+243 ...",
    "kyc.address": "Adresse physique *",
    "kyc.address_placeholder": "Numéro, avenue, commune…",
    "kyc.city": "Ville *",
    "kyc.country": "Pays *",
    "kyc.business_name": "Nom légal de l'entreprise *",
    "kyc.rccm": "RCCM *",
    "kyc.rccm_placeholder": "Ex: CD/KIN/RCCM/24-B-04135",
    "kyc.tax_id": "Numéro Impôt (NIF)",
    "kyc.id_doc_type": "Type de pièce *",
    "kyc.id_doc_id_card": "Carte d'électeur / d'identité",
    "kyc.id_doc_passport": "Passeport",
    "kyc.id_doc_permit": "Permis de conduire",
    "kyc.id_doc_number": "Numéro de la pièce *",
    "kyc.upload_id_label": "Photo de la pièce d'identité (recto/verso)",
    "kyc.upload_id_hint": "Photo claire, nette, entièrement visible. JPG/PNG/PDF max 5 Mo.",
    "kyc.upload_selfie_label": "Selfie avec votre pièce d'identité",
    "kyc.upload_selfie_hint": "Prenez-vous en photo tenant votre pièce à côté de votre visage. C'est pour prévenir toute usurpation.",
    "kyc.upload_proof_biz_label": "Photo du RCCM / registre de commerce",
    "kyc.upload_proof_ind_label": "Justificatif d'adresse (facture SNEL, REGIDESO, etc.)",
    "kyc.upload_proof_biz_hint": "Photo lisible du document officiel de votre entreprise.",
    "kyc.upload_proof_ind_hint": "Document de moins de 3 mois à votre nom.",
    "kyc.file_uploaded": "Document téléversé",
    "kyc.file_upload_fail": "Échec de l'upload",
    "kyc.file_too_big": "Fichier trop grand (max 5 Mo)",
    "kyc.uploading": "Téléversement…",
    "kyc.file_replace": "Fichier chargé — cliquez pour remplacer",
    "kyc.drop_file": "Cliquez ou glissez un fichier ici",
    "kyc.view": "Voir",
    "kyc.id_doc_view": "Pièce d'identité",
    "kyc.selfie_view": "Selfie",
    "kyc.proof_view": "Justificatif",
    "kyc.payout_note_pre": "Ce compte recevra vos paiements après validation. Il doit être",
    "kyc.payout_note_strong": "à votre nom",
    "kyc.payout_note_post": "(pas un tiers).",
    "kyc.method": "Méthode *",
    "kyc.method_mm": "Mobile Money (Vodacom / Airtel / Orange)",
    "kyc.method_bank": "Virement bancaire",
    "kyc.holder": "Titulaire du compte *",
    "kyc.holder_placeholder": "Nom + prénom exactement",
    "kyc.number_mm": "Numéro Mobile Money *",
    "kyc.number_bank": "Numéro de compte / IBAN *",
    "kyc.submit": "Soumettre pour vérification",
    "kyc.submitting": "Envoi…",
    "kyc.submit_hint": "En soumettant, vous acceptez le traitement de vos données personnelles selon nos CGV.",
    "kyc.err_docs": "Pièce d'identité + selfie requis",
    "kyc.err_rccm": "RCCM requis pour une entreprise",
    "kyc.sent": "Demande envoyée — vous recevrez une réponse sous 24-48h",
    "kyc.err_generic": "Erreur",

    // ===== BankTransfer =====
    "bt.title": "Instructions de virement",
    "bt.order": "Commande",
    "bt.amount": "Montant :",
    "bt.confirmed_banner": "Virement confirmé — votre commande est en préparation.",
    "bt.beneficiary": "Bénéficiaire du virement",
    "bt.accounts": "Comptes bancaires",
    "bt.transfer_instruction": "Effectuez votre virement sur l'un des comptes ci-dessous.",
    "bt.reference_required_pre": "Indiquez impérativement la référence",
    "bt.reference_required_post": "dans le libellé.",
    "bt.account_number": "N° compte",
    "bt.iban": "IBAN",
    "bt.swift": "SWIFT",
    "bt.currency": "Devise",
    "bt.send_proof_title": "Envoyer la preuve du virement",
    "bt.send_proof_desc": "Une fois le virement effectué, uploadez une capture d'écran ou le PDF du reçu. Le vendeur validera votre commande sous 24h.",
    "bt.file_label": "Fichier (photo ou PDF)",
    "bt.ref_optional": "Référence bancaire (facultatif)",
    "bt.ref_placeholder": "Ex: TXN-2026-08-0001",
    "bt.note_optional": "Note (facultatif)",
    "bt.note_placeholder": "Info complémentaire pour le vendeur…",
    "bt.send_proof": "Envoyer la preuve",
    "bt.sending": "Envoi…",
    "bt.proof_sent": "Preuve envoyée. Le vendeur va vérifier votre virement.",
    "bt.select_file": "Sélectionnez un fichier de preuve",
    "bt.awaiting_title": "✓ Preuve envoyée",
    "bt.awaiting_desc": "Votre preuve est en cours de vérification par le vendeur. Vous recevrez une notification dès qu'il aura confirmé.",
    "bt.see_orders": "Voir mes commandes →",
    "bt.copied": "Copié",
    "bt.connect": "Connectez-vous…",

    // ===== Payment (Stripe + PawaPay return pages) =====
    "pay.verify": "Vérification du paiement…",
    "pay.confirmed": "Paiement confirmé",
    "pay.confirmed_desc": "Merci pour votre commande. Votre reçu a été enregistré.",
    "pay.pawapay_confirmed_desc": "Merci ! Votre commande Mobile Money a été acceptée.",
    "pay.my_orders": "Mes commandes",
    "pay.home": "Accueil",
    "pay.pending_title": "Paiement en attente",
    "pay.pending_desc": "Nous n'avons pas confirmé votre paiement à temps. Consultez vos commandes.",
    "pay.pending_desc_pp": "Nous n'avons pas confirmé votre paiement à temps. Consultez vos commandes ou réessayez.",
    "pay.cancelled_title": "Paiement annulé",
    "pay.cancelled_desc": "Votre commande n'a pas été finalisée.",
    "pay.back_cart": "Retour au panier",
    "pay.verify_mm": "Vérification Mobile Money…",
    "pay.verify_mm_desc": "Nous confirmons votre paiement auprès de PawaPay.",

    // ===== Invoice =====
    "inv.print": "Imprimer / PDF",
    "inv.title": "FACTURE",
    "inv.number": "N°",
    "inv.issued_on": "Émise le",
    "inv.paid": "PAYÉE",
    "inv.pending": "EN ATTENTE",
    "inv.marketplace_by": "Marketplace opérée par",
    "inv.emitter": "Émetteur",
    "inv.emitter_operated_by": "Opéré par",
    "inv.emitter_note": "Facturation gérée par SUKANACOOP au nom du vendeur (marketplace).",
    "inv.customer": "Client",
    "inv.rccm": "RCCM :",
    "inv.tax_id": "ID Nat. :",
    "inv.designation": "Désignation",
    "inv.qty": "Qté",
    "inv.unit_price": "P.U.",
    "inv.total": "Total",
    "inv.product": "Produit",
    "inv.service": "Service",
    "inv.subtotal": "Sous-total",
    "inv.total_ttc": "Total TTC",
    "inv.shipping": "Livraison",
    "inv.coupon": "Réduction",
    "inv.pay_method": "Mode de paiement :",
    "inv.pay_bank_ref": "Virement bancaire (réf.",
    "inv.pay_pawapay": "Mobile Money / Carte via PawaPay",
    "inv.pay_card": "Carte bancaire (Stripe)",
    "inv.no_vat": "TVA non applicable, article 293 B du CGI (RDC).",
    "inv.thanks_pre": "Merci pour votre achat sur",
    "inv.thanks_marketplace": "SUKANACOOP, la marketplace opérée par",

    // ===== Legal notice =====
    "legal.info": "Informations légales",
    "legal.title": "Mentions légales",
    "legal.editor": "Éditeur du site",
    "legal.edited_by_pre": "Le site",
    "legal.edited_by_mid": "est édité et exploité par la société",
    "legal.legal_form": "Forme juridique",
    "legal.rccm": "RCCM",
    "legal.tax_id": "N° Impôt / ID Nat.",
    "legal.hq": "Siège social",
    "legal.phone": "Téléphone",
    "legal.email": "Email",
    "legal.manager": "Gérant",
    "legal.purpose": "Objet du site",
    "legal.purpose_desc_pre": "SUKANACOOP est une marketplace en ligne mettant en relation acheteurs, vendeurs de produits et prestataires de services. Les transactions sont opérées par",
    "legal.hosting": "Hébergement",
    "legal.hosting_desc": "Le site est hébergé sur l'infrastructure cloud d'Emergent.",
    "legal.payments": "Paiements & facturation",
    "legal.payments_desc_pre": "Les paiements sont traités via",
    "legal.payments_desc_mid": "(Mobile Money & carte bancaire) ou par",
    "legal.payments_desc_end": "sur les comptes de",
    "legal.payments_invoices_pre": "Toutes les factures liées aux transactions sont émises au nom de",
    "legal.contact": "Contact",
    "legal.contact_desc_pre": "Pour toute question, réclamation ou demande d'information, contactez-nous à",
    "legal.contact_desc_or": "ou au",
    "legal.bank_transfer": "virement bancaire",
    "legal.pawapay": "PawaPay",

    // ===== CGV / Remboursements =====
    "cgv.category": "Conditions & Remboursements",
    "cgv.title": "Conditions Générales de Vente & Politique de remboursement",
    "cgv.last_update": "Dernière mise à jour",
    "cgv.intro_pre": "est une marketplace opérée par la société",
    "cgv.intro_post": "Les présentes CGV régissent toute commande passée sur SUKANACOOP par un acheteur (particulier ou professionnel).",
    "cgv.footer.link": "CGV & Remboursements",

    "cgv.s1_title": "1. Objet",
    "cgv.s1_p1": "SUKANACOOP est une place de marché en ligne qui permet à des vendeurs indépendants et à SUKANACOOP elle-même de proposer des produits et des services aux acheteurs. SUKANACOOP agit en qualité d'intermédiaire technique et opère les paiements pour le compte des vendeurs.",
    "cgv.s1_p2": "En passant commande, l'acheteur reconnaît avoir pris connaissance et accepté sans réserve les présentes CGV.",

    "cgv.s2_title": "2. Commande & contrat",
    "cgv.s2_p1": "Le contrat de vente est formé dès validation du paiement. Une commande peut concerner :",
    "cgv.s2_li1": "un ou plusieurs produits vendus par un vendeur inscrit sur la marketplace,",
    "cgv.s2_li2": "un ou plusieurs services proposés par un prestataire inscrit,",
    "cgv.s2_li3": "des produits vendus directement par la boutique officielle SUKANACOOP.",

    "cgv.s3_title": "3. Prix, devises et taxes",
    "cgv.s3_p1": "Les prix sont affichés en EUR, USD ou CDF selon la préférence de l'acheteur. Le taux de conversion est mis à jour par SUKANACOOP. Le prix payé est celui en vigueur au moment de la commande.",
    "cgv.s3_p2": "Les commandes sont émises depuis la RDC : la TVA n'est pas applicable (article 293 B du CGI - régime RDC). Les frais douaniers éventuels à l'importation restent à la charge de l'acheteur.",

    "cgv.s4_title": "4. Modalités de paiement",
    "cgv.s4_p1": "Les paiements sont sécurisés et opérés par des prestataires agréés :",
    "cgv.s4_transfer": "Virement bancaire",
    "cgv.s4_transfer_desc": "sur les comptes de la société opératrice (Rawbank, Equity BCDC, TMB). Preuve de virement à téléverser depuis la page de suivi.",
    "cgv.s4_p2": "La commande n'est confirmée et transmise au vendeur qu'après confirmation effective du paiement.",

    "cgv.s5_title": "5. Livraison & disponibilité",
    "cgv.s5_p1": "Après paiement, SUKANACOOP dispose d'un délai de 6 heures pour confirmer la disponibilité de la commande auprès du vendeur (statuts : Disponible / Disponible plus tard / Épuisé). L'acheteur est notifié par email à chaque étape.",
    "cgv.s5_p2": "Les frais de livraison sont indiqués au checkout (Retrait gratuit, Kinshasa, Provinces RDC, International). Les délais indicatifs dépendent du transporteur choisi et de la destination.",

    "cgv.s6_summary_title": "En résumé",
    "cgv.s6_summary_li1": "France : demande de remboursement possible dans les 14 jours suivant la réception.",
    "cgv.s6_summary_li2": "RDC & autres pays : dans les 7 jours suivant la réception.",
    "cgv.s6_summary_li3": "Traitement de la demande sous 5 jours ouvrés, remboursement par le canal de paiement d'origine.",

    "cgv.s6_h1": "6.1 Droit de rétractation",
    "cgv.s6_p1": "Conformément à l'article L221-18 du Code de la consommation français, l'acheteur résidant en France dispose de 14 jours calendaires à compter de la réception du bien pour exercer son droit de rétractation, sans avoir à justifier de motif ni à supporter de pénalités (hors frais de retour). Pour les acheteurs résidant en RDC et dans les autres pays où le droit local ne prévoit pas de rétractation obligatoire, SUKANACOOP applique volontairement un délai commercial de 7 jours calendaires.",

    "cgv.s6_h2": "6.2 Comment demander un remboursement",
    "cgv.s6_inapp_title": "Méthode recommandée — depuis /commandes (2 clics)",
    "cgv.s6_inapp_desc": "Depuis votre espace acheteur, allez sur",
    "cgv.s6_inapp_link": "Mes commandes",
    "cgv.s6_inapp_desc_after": ", ouvrez la commande concernée et cliquez sur le bouton « Demander un remboursement » qui apparaît pour toute commande payée dans les 14 jours.",
    "cgv.s6_inapp_step1": "Choisissez un motif dans la liste (produit défectueux, non conforme, non livré, manquant, ou autre) et ajoutez un commentaire pour préciser votre situation.",
    "cgv.s6_inapp_step2": "Recevez un email d'accusé de réception sous quelques minutes. Notre équipe étudie votre demande sous 2 à 5 jours ouvrés.",
    "cgv.s6_inapp_step3": "Une fois validée, le remboursement est effectué automatiquement via le même canal que le paiement d'origine (Mobile Money PawaPay ou virement bancaire). Vous recevez un email de confirmation.",
    "cgv.s6_email_fallback_title": "Alternative — par email",
    "cgv.s6_p2": "Vous pouvez également nous contacter directement :",
    "cgv.s6_step1_pre": "Envoyez un email à",
    "cgv.s6_step1_post": "avec pour objet \"Demande de remboursement\", en précisant le numéro de commande, la raison et l'adresse email de votre compte.",
    "cgv.s6_step2": "Notre équipe accuse réception sous 24 h ouvrées et vous confirme l'éligibilité de la demande.",
    "cgv.s6_step3": "Notre équipe étudie votre demande sous 2 à 5 jours ouvrés et vous confirme la décision par email.",
    "cgv.s6_step4": "Une fois validée, le remboursement est effectué automatiquement via le même canal que le paiement d'origine (Mobile Money PawaPay ou virement bancaire). Vous recevez une confirmation email dès l'exécution.",
    "cgv.s6_return_note": "📦 Retour du produit — Le retour du bien n'est demandé que dans certains cas spécifiques (litige sur défaut, contestation de conformité, produit nécessitant une expertise). Dans ces situations, notre équipe vous transmet séparément une adresse de retour et des instructions dédiées ; le délai de remboursement démarre alors à réception du colis.",

    "cgv.s6_h3": "6.3 Canal de remboursement",
    "cgv.s6_ch_pawapay": "PawaPay Mobile Money — remboursement automatique sur le numéro mobile utilisé lors du paiement.",
    "cgv.s6_ch_transfer": "Virement bancaire — remboursement sur le compte d'origine du virement (ou tout autre compte fourni par l'acheteur avec accord préalable).",

    "cgv.s6_h4": "6.4 Cas particuliers & exclusions",
    "cgv.s6_p4": "Certains biens ou services ne peuvent faire l'objet d'un remboursement, conformément à l'article L221-28 du Code de la consommation :",
    "cgv.s6_excl1": "les services entièrement exécutés avant la fin du délai de rétractation, avec accord préalable de l'acheteur,",
    "cgv.s6_excl2": "les biens personnalisés, périssables ou descellés à caractère hygiénique,",
    "cgv.s6_excl3": "les prestations de voyage, d'hébergement ou de restauration à date fixe.",

    "cgv.s7_title": "7. Garantie légale de conformité",
    "cgv.s7_p1": "Les acheteurs bénéficient de la garantie légale de conformité et de la garantie des vices cachés prévues par les articles L217-4 et suivants du Code de la consommation français, ou par le droit local applicable. En cas de produit défectueux ou non conforme, contactez-nous par email dans les délais légaux.",

    "cgv.s8_title": "8. Responsabilité & réclamations",
    "cgv.s8_p1": "SUKANACOOP met tout en œuvre pour assurer la fiabilité de la marketplace mais ne peut être tenue responsable des retards indépendants de sa volonté (transporteurs, force majeure). En cas de litige avec un vendeur, l'acheteur peut ouvrir une réclamation depuis sa commande ; notre équipe interviendra pour trouver une solution amiable.",

    "cgv.s9_title": "9. Protection des données personnelles",
    "cgv.s9_p1": "Vos données sont traitées conformément au Règlement Général sur la Protection des Données (RGPD) et à la loi congolaise n°20/017 relative aux télécommunications. Vous pouvez à tout moment demander l'accès, la rectification ou la suppression de vos données par email. Voir également notre page Mentions légales.",

    "cgv.s10_p1": "Pour toute question relative aux présentes CGV ou à une demande de remboursement, contactez notre équipe SUKANACOOP :",
    "cgv.s10_title": "10. Contact",
    "cgv.phone_label": "Téléphone",
    "cgv.chat_hint": "Bulle de discussion en bas à droite du site (réponse rapide en journée).",

    "cgv.footer_note_pre": "Les présentes CGV sont soumises au droit congolais pour les transactions opérées par",
    "cgv.footer_note_post": "Tout litige relève, à défaut d'accord amiable, des juridictions compétentes de Kinshasa (RDC) — sans préjudice des dispositions impératives applicables aux acheteurs consommateurs de leur pays de résidence.",

    // ===== Notifications =====
    "notif.title": "Centre de notifications",
    "notif.back": "Retour",
    "notif.unread": "non lues",
    "notif.total": "au total",
    "notif.all_read": "Toutes vos notifications sont à jour ✓",
    "notif.mark_all_read": "Tout marquer comme lu",
    "notif.mark_read": "Marquer lu",
    "notif.marked_read": "notifications marquées comme lues",
    "notif.empty_title": "Aucune notification",
    "notif.empty_desc": "Vous serez averti·e ici à chaque nouvelle commande, paiement confirmé, KYC ou reversement.",

    // ===== RGPD (Export + Deletion) =====
    "rgpd.section_title": "Vie privée & données personnelles",
    "rgpd.section_desc": "Conformément au RGPD (Article 17 & 20), vous pouvez à tout moment télécharger toutes vos données personnelles ou supprimer votre compte.",
    "rgpd.export_title": "Télécharger mes données (JSON)",
    "rgpd.export_desc": "Récupérez un fichier JSON contenant votre profil, vos commandes, avis, messages, abonnements, préférences.",
    "rgpd.export_cta": "Télécharger mes données",
    "rgpd.export_success": "Votre export a été téléchargé ✓",
    "rgpd.delete_title": "Supprimer mon compte",
    "rgpd.delete_desc": "Anonymise définitivement votre compte. Les factures et paiements sont conservés (obligation légale) mais dissociés de votre profil personnel.",
    "rgpd.delete_cta": "Supprimer mon compte",
    "rgpd.delete_success": "Votre compte a été supprimé. À bientôt.",
    "rgpd.modal_title": "Confirmer la suppression du compte",
    "rgpd.modal_desc": "Cette action est irréversible. Une fois validée, vous ne pourrez plus vous reconnecter avec cet email.",
    "rgpd.modal_kept": "Conservé : commandes, factures, reversements (obligation comptable France/RDC, 10 ans)",
    "rgpd.modal_erased": "Supprimé : documents KYC, messages, favoris, notifications, panier, préférences",
    "rgpd.modal_login": "Blocage définitif de la reconnexion sur cet email",
    "rgpd.modal_confirm_label": "Tapez SUPPRIMER pour confirmer",
    "rgpd.modal_password_label": "Confirmez votre mot de passe *",
    "rgpd.modal_reason_label": "Motif (facultatif)",
    "rgpd.modal_reason_placeholder": "Aidez-nous à améliorer SUKANACOOP…",
    "rgpd.modal_confirm_cta": "Supprimer définitivement",

    // ===== Cookies (RGPD/CNIL banner) =====
    "cookies.banner_title": "🍪 Vous êtes sur SUKANACOOP",
    "cookies.banner_desc": "Nous utilisons des cookies strictement nécessaires (panier, session, langue). Aucun cookie de mesure d'audience ou de publicité n'est activé sans votre consentement.",
    "cookies.accept_all": "Tout accepter",
    "cookies.refuse_all": "Tout refuser",
    "cookies.configure": "Paramétrer",
    "cookies.save_choices": "Enregistrer mes choix",
    "cookies.learn_more": "En savoir plus",
    "cookies.footer_link": "Gérer les cookies",
    "cookies.config_title": "Paramétrer les cookies",
    "cookies.config_desc": "Choisissez précisément les catégories de cookies que vous autorisez. Les cookies strictement nécessaires ne peuvent pas être désactivés (ils font fonctionner le site).",
    "cookies.cat_necessary_title": "Strictement nécessaires (toujours actifs)",
    "cookies.cat_necessary_desc": "Cookies indispensables : session de connexion, panier d'achat, choix de langue et de devise. Sans eux, SUKANACOOP ne peut pas fonctionner. Exemptés de consentement (CNIL).",
    "cookies.cat_analytics_title": "Mesure d'audience anonyme",
    "cookies.cat_analytics_desc": "Nous permettent de comprendre comment vous naviguez sur le site pour l'améliorer (aucune donnée personnelle vendue). Aucun outil de mesure n'est actif à ce jour.",
    "cookies.cat_marketing_title": "Publicité & personnalisation",
    "cookies.cat_marketing_desc": "Cookies utilisés pour vous proposer des offres pertinentes ou du reciblage sur d'autres sites. Aucun outil de ce type n'est actif à ce jour.",

    // ===== France plans launch waitlist =====
    "sub.fr.section_title": "🇫🇷 Offres France — bientôt disponibles",
    "sub.fr.section_desc": "Les boutiques françaises pourront bientôt s'abonner aux offres SUKANACOOP en EUR. Inscrivez-vous pour être informé·e du lancement.",
    "sub.fr.notify_cta": "🔔 Être informé du lancement",
    "sub.fr.coming_soon": "Bientôt disponible",
    "sub.fr.audit_note": "Validation fiscale et juridique en cours",
    "sub.fr.modal_title": "Recevoir le lancement des offres France",
    "sub.fr.modal_desc": "Laissez-nous vos coordonnées : nous vous préviendrons dès que les formules France seront actives.",
    "sub.fr.form_email": "Email",
    "sub.fr.form_name": "Nom / Prénom",
    "sub.fr.form_company": "Nom de votre commerce (facultatif)",
    "sub.fr.form_plan": "Formule qui vous intéresse",
    "sub.fr.form_note": "Un message pour nous (facultatif)",
    "sub.fr.form_submit": "M'inscrire à la liste d'attente",
    "sub.fr.form_success": "Merci ! Nous vous préviendrons dès le lancement.",
    "sub.fr.form_already": "Vous êtes déjà inscrit·e à cette liste d'attente ✓",

    // ===== Messages =====
    "msg.title": "Messagerie",
    "msg.no_conv": "Aucune conversation.",
    "msg.select": "Sélectionnez une conversation",
    "msg.user": "Utilisateur",
    "msg.placeholder": "Votre message…",
    "msg.send": "Envoyer",

    // ===== Forgot password =====
    "fp.title": "Mot de passe oublié",
    "fp.desc": "Entrez votre email pour recevoir un lien de réinitialisation.",
    "fp.email": "Email",
    "fp.send": "Envoyer",
    "fp.new_title": "Nouveau mot de passe",
    "fp.token": "Token",
    "fp.new_pw": "Nouveau mot de passe",
    "fp.reset": "Réinitialiser",
    "fp.pw_changed": "Mot de passe modifié",
    "fp.login_link": "Se connecter",
    "fp.email_sent": "Si le compte existe, un email a été envoyé (mock).",
    "fp.debug_prefill": "Token debug pré-rempli",
    "fp.reset_success": "Mot de passe réinitialisé ! Vous pouvez vous connecter.",
    "fp.err": "Erreur",

    // ===== Seller Dashboard =====
    "sd.title": "Tableau de bord vendeur",
    "sd.verified": "Compte vérifié",
    "sd.pending_verif": "Vérification en cours",
    "sd.verify_cta": "Vérifier mon compte",
    "sd.correct_verif": "Corriger ma vérification",
    "sd.verif_refused": "Vérification refusée",
    "sd.verif_required": "Vérification requise",
    "sd.verif_reason": "Motif :",
    "sd.verif_help_pre": "Complétez votre vérification KYC pour publier plus de",
    "sd.verif_help_post": "annonces et recevoir vos paiements.",
    "sd.verif_correct_hint": ". Corrigez et resoumettez.",
    "sd.suspended": "Compte suspendu",
    "sd.suspended_contact": "Contactez l'administrateur pour plus d'informations.",
    "sd.start": "Démarrer",
    "sd.stat_products": "Produits",
    "sd.stat_services": "Services",
    "sd.stat_orders": "Commandes",
    "sd.stat_revenue": "CA",
    "sd.tab_products": "Produits",
    "sd.tab_services": "Services",
    "sd.tab_orders": "Commandes",
    "sd.tab_revenue": "Revenus",
    "sd.new_product": "Nouveau produit",
    "sd.new_service": "Nouveau service",
    "sd.count_products": "produit(s)",
    "sd.count_services": "service(s)",
    "sd.no_orders": "Aucune commande.",
    "sd.stock": "Stock:",
    "sd.proof_received": "📎 Preuve de virement reçue",
    "sd.view_proof": "Voir la preuve",
    "sd.confirm_transfer": "✓ Confirmer le virement",
    "sd.confirm_transfer_prompt": "Confirmer que vous avez bien reçu le virement ?",
    "sd.transfer_confirmed": "Virement confirmé — l'acheteur est notifié",
    "sd.status_updated": "Statut mis à jour",
    "sd.deleted": "Supprimé",
    "sd.confirm_delete": "Supprimer ?",
    "sd.pending_days_pre": "En attente",
    "sd.available": "Disponible",
    "sd.paid_out": "Déjà reversé",
    "sd.commission_note": "Commission SUKANACOOP :",
    "sd.retention": "Rétention :",
    "sd.days_after": "jours après paiement",
    "sd.no_paid_orders": "Aucune commande payée pour l'instant.",
    "sd.sale": "Vente",
    "sd.commission": "Commission",
    "sd.net": "Net",
    "sd.paid_out_badge": "Reversé",
    "sd.to_release": "À reverser",
    "sd.blocked_until": "Bloqué",
    "sd.tab_shop": "Boutique",
    "sd.shop_placeholder": "Votre boutique",
    "sd.shop_logo": "Logo (carré, 200×200 recommandé)",
    "sd.shop_logo_hint": "Affiché sur votre fiche boutique et vos annonces.",
    "sd.shop_cover": "Photo de couverture (large, 1200×400 recommandé)",
    "sd.shop_cover_hint": "Bannière affichée en tête de votre boutique et sur /boutiques.",
    "sd.shop_name": "Nom de la boutique",
    "sd.shop_desc": "Présentation de votre boutique",
    "sd.shop_desc_placeholder": "Racontez qui vous êtes, ce que vous vendez, votre histoire…",
    "sd.shop_location": "Ville / région",
    "sd.shop_save": "Enregistrer ma boutique",
    "sd.shop_saved": "Boutique mise à jour ✓",
    "sd.shop_published_on": "Boutique publiée",
    "sd.shop_published_off": "Boutique en pause",
    "sd.shop_published_hint_on": "Votre boutique et vos annonces sont visibles par tous les acheteurs.",
    "sd.shop_published_hint_off": "Votre boutique et vos annonces sont masquées. Vous pouvez la réactiver à tout moment.",
    "sd.subscription_link": "Mon abonnement",

    // ===== Shop Detail (FR) =====
    "shop.not_found_title": "Boutique introuvable",
    "shop.not_found_desc": "Cette boutique n'existe pas ou a été mise en pause par son propriétaire.",
    "shop.back_to_directory": "Retour au répertoire des boutiques",
    "shop.member_since": "Membre depuis",
    "shop.paused": "En pause",
    "shop.products": "Produits",
    "shop.services": "Services",
    "shop.no_items": "Cette boutique n'a pas encore publié d'annonce.",
    "shop.reviews": "avis",

    // ===== Personal Shopper (FR) =====
    "nav.personal_shopper": "Personal Shopper",
    "ps.eyebrow": "Conciergerie d'achat internationale",
    "ps.title_line1": "Achetez partout,",
    "ps.title_line2": "nous nous occupons du reste.",
    "ps.subtitle": "Vous souhaitez acheter des produits dans des enseignes reconnues en Europe ou au Congo, mais vous ne pouvez pas vous déplacer ou le magasin ne livre pas dans votre pays ? SUKANACOOP Personal Shopper achète pour vous et vous livre à domicile.",
    "ps.cta_start": "Faire une demande",
    "ps.cta_how": "Comment ça marche",
    "ps.how_eyebrow": "PROCESSUS",
    "ps.how_title": "5 étapes simples, aucun stress",
    "ps.step.send_refs.title": "1. Envoyez vos références",
    "ps.step.send_refs.desc": "Liens produits ou nom du magasin",
    "ps.step.receive_quote.title": "2. Recevez un devis",
    "ps.step.receive_quote.desc": "Sous 24-48h, transparent et détaillé",
    "ps.step.we_buy.title": "3. Nous achetons",
    "ps.step.we_buy.desc": "Après votre validation et paiement",
    "ps.step.we_ship.title": "4. Emballage & expédition",
    "ps.step.we_ship.desc": "Suivi de colis en temps réel",
    "ps.step.delivered.title": "5. Livré chez vous",
    "ps.step.delivered.desc": "À l'adresse indiquée",
    "ps.where_eyebrow": "SECTEURS",
    "ps.where_title": "Où faisons-nous vos achats ?",
    "ps.where_desc": "Enseignes reconnues en Europe et au Congo, selon la disponibilité et les réglementations d'importation.",
    "ps.cat.fashion": "Mode & Accessoires",
    "ps.cat.beauty": "Beauté & Cosmétiques",
    "ps.cat.baby": "Produits Bébé",
    "ps.cat.electronics": "Électronique",
    "ps.cat.home": "Maison & Déco",
    "ps.cat.sport": "Sport",
    "ps.cat.auto": "Pièces auto",
    "ps.cat.cleaning": "Produits d'entretien",
    "ps.cat.food": "Alimentation",
    "ps.commit_eyebrow": "NOS ENGAGEMENTS",
    "ps.commit_title": "Vous êtes entre de bonnes mains",
    "ps.commit.trusted_brands": "Achat auprès d'enseignes reconnues",
    "ps.commit.transparent": "Transparence totale des prix",
    "ps.commit.quote_first": "Devis avant chaque commande",
    "ps.commit.tracking": "Suivi de votre colis",
    "ps.commit.personal_support": "Accompagnement personnalisé",
    "ps.pricing_title": "Tarification transparente",
    "ps.pricing_desc": "Le montant total est communiqué avant toute validation. Vous ne payez que si vous acceptez le devis.",
    "ps.fee.products": "Prix des produits",
    "ps.fee.service_fee": "Frais Personal Shopper",
    "ps.fee.packaging": "Emballage si nécessaire",
    "ps.fee.shipping": "Livraison selon pays",
    "ps.pricing_footnote": "Devis gratuit et sans engagement.",
    "ps.form_eyebrow": "DEMANDE PERSONNALISÉE",
    "ps.form_title": "Faire une demande",
    "ps.form_subtitle": "Remplissez le formulaire ci-dessous — notre équipe vous répondra sous 24-48h avec un devis détaillé.",
    "ps.f.name": "Nom et prénom",
    "ps.f.email": "Email",
    "ps.f.phone": "Téléphone (WhatsApp de préférence)",
    "ps.f.country": "Pays de livraison",
    "ps.f.link": "Lien du produit ou nom du magasin",
    "ps.f.link_hint": "Si vous n'avez pas de lien, décrivez précisément le produit ci-dessous.",
    "ps.f.description": "Description du produit",
    "ps.f.description_placeholder": "Marque, modèle, couleur, taille, spécifications techniques…",
    "ps.f.quantity": "Quantité",
    "ps.f.budget": "Budget approximatif",
    "ps.f.photo": "Photo du produit (facultatif)",
    "ps.f.comments": "Commentaires ou demandes particulières",
    "ps.f.comments_placeholder": "Délai souhaité, alternatives acceptées, questions…",
    "ps.submit": "Envoyer ma demande",
    "ps.submit_hint": "Aucun paiement requis. Vous validez uniquement après réception du devis.",
    "ps.required_fields": "Merci de remplir les champs obligatoires (*)",
    "ps.submitted": "✅ Votre demande a bien été envoyée",
    "ps.uploading": "Envoi en cours…",
    "ps.photo_added": "Photo ajoutée ✓",
    "ps.photo_fail": "Échec de l'envoi de la photo",
    "ps.thanks_title": "Merci ! Votre demande est bien reçue 🙏",
    "ps.thanks_desc": "Notre équipe SUKANACOOP Personal Shopper vérifie la disponibilité du produit et vous enverra un devis personnalisé sous 24 à 48h ouvrées. Vous recevrez un email de confirmation immédiat, puis le devis complet dès qu'il sera prêt.",
    "ps.new_request": "Faire une autre demande",

    // Personal Shopper — Calculateur de devis
    "psq.eyebrow": "CALCULATEUR",
    "psq.title": "Estimez le coût de votre commande",
    "psq.subtitle": "Un devis instantané, sans engagement. Vous validez uniquement si le prix vous convient.",
    "psq.tab_quote": "Devis",
    "psq.tab_settings": "Paramètres",
    "psq.tbd": "à définir",
    "psq.scenario": "Type de commande",
    "psq.f_name": "Nom complet",
    "psq.f_email": "Email",
    "psq.f_phone": "Téléphone",
    "psq.f_country": "Pays",
    "psq.order_details": "Détails de la commande",
    "psq.f_amount": "Montant achats",
    "psq.f_weight": "Poids",
    "psq.f_zone": "Zone de livraison (Kinshasa)",
    "psq.f_destination": "Destination livraison",
    "psq.france_tbd": "Tarif Congo → France pas encore défini. Le devis sera généré avec 0 $ de livraison — notre équipe reviendra vers vous avec le tarif exact sous 24-48h.",
    "psq.download_pdf": "Télécharger le devis (PDF)",
    "psq.p_france_freight": "Livraison Congo → France / kg",

    // Notify me — back-in-stock
    "notifyme.title": "Prévenez-moi quand le produit revient",
    "notifyme.desc": "Laissez-nous votre email et nous vous notifierons dès que ce produit est à nouveau disponible.",
    "notifyme.name_ph": "Votre prénom (facultatif)",
    "notifyme.email_ph": "email@example.com",
    "notifyme.cta": "M'avertir dès son retour",
    "notifyme.sending": "Envoi…",
    "notifyme.ok": "Parfait — on vous préviendra dès son retour en stock",
    "notifyme.already": "Vous êtes déjà dans la liste — on vous préviendra",
    "notifyme.err_email": "Email requis",
    "notifyme.done_title": "Alerte activée",
    "notifyme.done_desc": "Vous serez averti par email dès que ce produit est de retour en stock.",
    "psq.f_notes": "Note ou précision",
    "psq.f_notes_ph": "Lien produit, marque, taille, référence…",
    "psq.summary": "Récapitulatif",
    "psq.r_products": "Achats produit",
    "psq.r_commission": "Commission",
    "psq.r_freight": "Fret",
    "psq.r_delivery": "Livraison",
    "psq.r_total": "Total",
    "psq.submit": "Recevoir mon devis",
    "psq.sent": "Devis envoyé",
    "psq.err_required": "Nom et email obligatoires",
    "psq.err_amount": "Montant d'achat requis",
    "psq.err_inactive": "Ce scénario n'est pas encore disponible",
    "psq.disclaimer": "Estimation indicative — le prix final est confirmé sous 24-48h.",
    "psq.your_quote": "Votre devis",
    "psq.success_desc": "Nous vous avons envoyé le devis par email. Notre équipe vous contactera sous 24-48h pour confirmer et lancer votre commande.",
    "psq.new_quote": "Nouveau devis",
    "psq.load_fail": "Erreur chargement paramètres",
    "psq.p_usd_eur": "USD → EUR",
    "psq.p_usd_cdf": "USD → CDF",
    "psq.p_freight": "Fret / kg",
    "psq.p_tiers": "COMMISSIONS PAR PALIER",
    "psq.p_tiers_title": "Commission SUKANACOOP sur vos achats",
    "psq.p_col_range": "Montant achats ($)",
    "psq.p_col_pct": "Commission SUKANACOOP",
    "psq.and_more": "et plus",
    "psq.p_zones": "LIVRAISON KINSHASA",
    "psq.p_zones_title": "Tarifs de livraison par zone (FC)",
    "psq.p_scenarios": "SCÉNARIOS DE COMMANDE",
    "psq.p_scenarios_title": "Où nous intervenons",


    "shop.not_found_desc": "Cette boutique n'existe pas ou a été mise en pause par son propriétaire.",
    "shop.back_to_directory": "Retour au répertoire des boutiques",
    "shop.member_since": "Membre depuis",
    "shop.paused": "En pause",
    "shop.products": "Produits",
    "shop.services": "Services",
    "shop.no_items": "Cette boutique n'a pas encore publié d'annonce.",
    "shop.reviews": "avis",

    // ===== Subscription page =====
    "sub.title": "Abonnements vendeurs",
    "sub.subtitle": "Choisissez le plan adapté à votre activité. Résiliable à tout moment. Aucun engagement.",
    "sub.back": "Retour au tableau de bord",
    "sub.promo_title": "🎁 3 mois gratuits pour le lancement",
    "sub.promo_desc": "Testez Standard ou Pro sans débourser un centime. Après la période d'essai, facturation automatique. Résiliez quand vous voulez.",
    "sub.current_plan": "Votre plan actuel",
    "sub.commission": "Commission actuelle :",
    "sub.listings_used": "annonces publiées",
    "sub.trial_active": "Période d'essai active — profitez de tous les avantages",
    "sub.will_cancel": "Résiliation programmée à la fin de la période en cours",
    "sub.cancel_btn": "Résilier",
    "sub.cancel_confirm": "Résilier votre abonnement ? Vous conserverez vos avantages jusqu'à la fin de la période en cours.",
    "sub.cancel_scheduled": "Résiliation programmée",
    "sub.popular": "Le plus populaire",
    "sub.month": "mois",
    "sub.trial_days": "jours d'essai gratuit",
    "sub.your_plan": "Votre plan actuel",
    "sub.choose_plan": "Choisir ce plan",
    "sub.default_plan": "Plan par défaut",
    "sub.downgrade_at_end": "Repasser au gratuit",
    "sub.activated": "Abonnement activé ! 🎉",
    "sub.cancelled": "Achat annulé — aucun débit effectué",
    "sub.faq_1_q": "Puis-je changer de plan ?",
    "sub.faq_1_a": "Oui, à tout moment. Le nouveau plan prend effet à la prochaine période de facturation.",
    "sub.faq_2_q": "Que se passe-t-il après les 3 mois gratuits ?",
    "sub.faq_2_a": "La facturation démarre automatiquement au prix affiché. Vous pouvez résilier à tout moment avant.",
    "sub.faq_3_q": "Comment sont facturés les prix ?",
    "sub.faq_3_a": "Les prix affichés sont en USD, prélevés mensuellement via Stripe. Le paiement est sécurisé (SSL, PCI-DSS).",
    "sd.import_csv": "Importer CSV",
    "sd.csv_dialog_title": "Import en masse par CSV",
    "sd.csv_format": "Format attendu (1ère ligne = en-têtes) :",
    "sd.csv_hint": "Séparateur : virgule (,) ou point-virgule (;). Encodage : UTF-8.",
    "sd.csv_images_hint": "Champ « images » : URLs séparées par une barre verticale |",
    "sd.csv_file": "Fichier CSV",
    "sd.csv_pick_file": "Choisissez un fichier CSV",
    "sd.csv_import_btn": "Lancer l'import",
    "sd.csv_importing": "Import en cours…",
    "sd.csv_imported": "annonce(s) créée(s)",
    "sd.csv_created": "créée(s)",
    "sd.csv_skipped": "ignorée(s)",

    // ===== Item form (product/service editor) =====
    "if.title": "Titre",
    "if.description": "Description",

    // ===== Chatbot =====
    "chat.title": "Assistant SUKANACOOP",
    "chat.subtitle": "En ligne · répond en quelques secondes",
    "chat.greeting": "Bonjour ! 👋 Je suis l'assistant SUKANACOOP. Comment puis-je vous aider aujourd'hui ?",
    "chat.placeholder": "Écrivez votre message…",
    "chat.thinking": "L'assistant réfléchit…",
    "chat.open": "Ouvrir le chat",
    "chat.close": "Fermer",
    "chat.error": "Je rencontre un souci. Réessayez ou contactez-nous sur WhatsApp.",
    "whatsapp.label": "Nous contacter sur WhatsApp",
    "whatsapp.greeting": "Bonjour SUKANACOOP, j'ai une question :",

    // ===== Directory (Shops & providers) =====
    "dir.title": "Nos boutiques & prestataires",
    "dir.subtitle": "Découvrez tous nos vendeurs et prestataires vérifiés à travers la France et la RDC.",
    "dir.header_link": "Boutiques",
    "dir.official": "Officiel",
    "dir.stat_products": "produit(s)",
    "dir.stat_services": "service(s)",
    "dir.visit": "Voir la boutique",
    "dir.empty": "Aucune boutique publiée pour le moment.",
    "dir.search": "Rechercher une boutique…",
    "dir.filter_all": "Toutes",
    "dir.filter_products": "Boutiques (produits)",
    "dir.filter_services": "Prestataires (services)",
    "dir.count": "boutique(s) & prestataire(s)",
    "dir.joined": "Inscrit(e) en",
    "if.en_toggle_hide": "Masquer la version anglaise",
    "if.en_toggle_show": "Ajouter / modifier la version anglaise",
    "if.en_hint": "Optionnel — si vide, la traduction sera générée automatiquement à la première visite d'un client en anglais.",
    "if.title_en": "Titre (EN)",
    "if.description_en": "Description (EN)",
    "if.auto_translate": "🤖 Traduire automatiquement",
    "if.translating": "Traduction en cours…",
    "if.translated": "Traduction générée",
    "if.translate_fill_first": "Remplissez d'abord le titre et la description en français",
    "if.prices": "Prix par devise",
    "if.price_note": "EUR est le prix de référence. USD et CDF sont affichés selon la devise choisie par l'acheteur.",
    "if.stock": "Stock",
    "if.category": "Catégorie",
    "if.choose": "Choisir…",
    "if.zone": "Zone géographique",
    "if.location": "Localisation",
    "if.images": "Images",
    "if.image_url": "Ou saisissez une URL :",
    "if.image_added": "Image ajoutée",
    "if.upload_fail": "Échec de l'upload",
    "if.save": "Enregistrer",
    "if.cancel": "Annuler",
    "if.updated": "Mis à jour",
    "if.created": "Créé",
    "if.error": "Erreur",
    "if.new": "Nouveau",
    "if.edit": "Modifier",
    "if.product": "produit",
    "if.service": "service",
    "if.booking_enable": "Activer la réservation de créneaux",
    "if.booking_duration": "Durée d'un créneau",
    "if.booking_add_slot": "Ajouter un créneau disponible",
    "if.booking_add": "Ajouter",
    "if.booking_pick_first": "Choisissez d'abord une date/heure",
    "if.booking_dup": "Ce créneau est déjà dans la liste",
    "if.booking_slots_count": "créneau(x) proposé(s)",
    "if.booking_hint": "Les acheteurs pourront réserver l'un de ces créneaux directement depuis la fiche du service.",

    // ===== Admin Dashboard =====
    "ad.title": "Administration",
    "ad.stat_users": "Utilisateurs",
    "ad.stat_products": "Produits",
    "ad.stat_orders": "Commandes",
    "ad.stat_revenue": "Revenus",
    "ad.stat_revenue_30d": "CA · 30 jours",
    "ad.stat_commission": "Commission estimée",
    "ad.stat_paid_orders": "commandes payées",
    "ad.stat_active_sellers": "Vendeurs actifs",
    "ad.stat_verified_sellers": "vérifiés KYC",
    "ad.stat_payouts_due": "À reverser (débloqué)",
    "ad.stat_held": "Bloqué",
    "ad.stat_paying_subs": "Abonnements payants",
    "ad.stat_trialing": "en essai gratuit",
    "ad.stat_top_sellers": "Top 5 vendeurs (par CA)",
    "ad.stat_top_products": "Top 5 produits & services",
    "ad.stat_units_sold": "unités vendues",
    "ad.stat_no_data": "Aucune donnée pour l'instant — les premières ventes s'afficheront ici.",
    "ad.tab_users": "Utilisateurs",
    "ad.tab_kyc": "KYC",
    "ad.tab_payouts": "Reversements",
    "ad.tab_categories": "Catégories",
    "ad.tab_orders": "Commandes",
    "ad.tab_currency": "Devises",
    "ad.tab_banks": "Comptes",
    "ad.tab_company": "Société",
    "ad.tab_coupons": "Coupons",
    "ad.tab_platform": "Plateforme",
    "ad.tab_waitlist_fr": "Waitlist FR",
    "ad.tab_refunds": "Remboursements",
    "ad.refunds_title": "Demandes de remboursement",
    "ad.refunds_intro": "Approuvez ou refusez les demandes de remboursement des acheteurs. Un remboursement PawaPay approuvé appelle automatiquement l'API PawaPay. Un virement bancaire nécessite votre action manuelle après approbation.",
    "ad.refunds_empty": "Aucune demande en attente. Bravo — vos clients sont satisfaits ✨",
    "ad.refunds_count": "demande(s) en attente",
    "ad.refunds_col_date": "Date",
    "ad.refunds_col_order": "Commande",
    "ad.refunds_col_buyer": "Acheteur",
    "ad.refunds_col_amount": "Montant",
    "ad.refunds_col_provider": "Paiement",
    "ad.refunds_col_reason": "Motif",
    "ad.refunds_col_action": "Action",
    "ad.refunds_approve": "Approuver",
    "ad.refunds_reject": "Refuser",
    "ad.refunds_amount_optional": "Montant à rembourser (facultatif — total par défaut)",
    "ad.refunds_reject_reason": "Motif de refus (obligatoire)",
    "ad.refunds_reject_ph": "Expliquez pourquoi la demande est refusée — l'acheteur recevra ce texte par email.",
    "ad.refunds_confirm_approve": "Approuver ce remboursement ? Un remboursement PawaPay sera exécuté automatiquement.",
    "ad.refunds_confirm_reject": "Refuser cette demande de remboursement ?",
    "ad.refunds_approved_toast": "Remboursement approuvé et exécuté",
    "ad.refunds_rejected_toast": "Demande refusée — l'acheteur a été notifié",
    "ad.refunds_reason_defective": "Produit défectueux",
    "ad.refunds_reason_not_as_described": "Non conforme",
    "ad.refunds_reason_not_delivered": "Non livrée",
    "ad.refunds_reason_missing_item": "Produit manquant",
    "ad.refunds_reason_other": "Autre",
    "ad.refunds_view_details": "Voir le détail",
    "ad.refunds_buyer_payout": "Coordonnées du client",
    "ad.refunds_close": "Fermer",
    "ad.refunds_retry_title": "⚠️ Tentative précédente échouée",
    "ad.refunds_retry_pp_reason": "Motif PawaPay",
    "ad.refunds_retry_hint": "Rechargez d'abord votre portefeuille PawaPay puis cliquez à nouveau sur Approuver pour relancer.",
    "ad.wl_title": "Prospects France — liste d'attente",
    "ad.wl_intro": "Commerçants français qui ont demandé à être prévenus au lancement des offres Starter / Business / Premium (audit fiscal et juridique en cours). Exportez la liste pour préparer votre lancement commercial.",
    "ad.wl_leads_count": "prospect(s) inscrit(s)",
    "ad.wl_export": "Exporter en CSV",
    "ad.wl_exported": "prospects exportés en CSV",
    "ad.wl_empty": "Aucun prospect pour le moment. Le formulaire est accessible depuis la page « Devenir vendeur » (section France).",
    "ad.wl_col_date": "Date",
    "ad.wl_col_email": "Email",
    "ad.wl_col_name": "Nom / Prénom",
    "ad.wl_col_company": "Commerce",
    "ad.wl_col_plan": "Offre",
    "ad.wl_col_note": "Message",
    "ad.confirm_delete": "Supprimer ?",
    "ad.deleted": "Supprimé",
    "ad.cat_name": "Nom",
    "ad.cat_slug": "Slug",
    "ad.cat_type": "Type",
    "ad.cat_add": "Ajouter",
    "ad.cat_product": "Produit",
    "ad.cat_service": "Service",
    "ad.cat_both": "Mixte",
    "ad.cat_created": "Créée",
    "ad.rates_title": "Taux de change",
    "ad.rates_base": "Devise pivot :",
    "ad.rates_save": "Enregistrer les taux",
    "ad.rates_saved": "Taux mis à jour",
    "ad.rates_hint": "Ces taux servent d'approximation pour l'affichage des prix aux acheteurs. Les prix de référence sont exprimés en EUR (devise pivot).",
    "ad.banks_title": "Comptes bancaires",
    "ad.banks_hint": "Ces coordonnées sont affichées aux acheteurs qui choisissent le virement bancaire.",
    "ad.banks_add": "Ajouter un compte",
    "ad.banks_bank": "Banque",
    "ad.banks_holder": "Titulaire",
    "ad.banks_number": "N° de compte",
    "ad.banks_iban": "IBAN (facultatif)",
    "ad.banks_swift": "SWIFT / BIC",
    "ad.banks_currency": "Devise",
    "ad.banks_country": "Pays",
    "ad.banks_notes": "Notes",
    "ad.banks_remove": "Supprimer",
    "ad.banks_save": "Enregistrer",
    "ad.banks_saved": "Comptes bancaires mis à jour",
    "ad.banks_empty": "Aucun compte. Cliquez sur \"Ajouter un compte\" pour commencer.",
    "ad.co_title": "Informations de la société",
    "ad.co_hint": "Ces infos apparaissent sur le footer, les mentions légales, les factures et la page de virement bancaire.",
    "ad.co_name": "Raison sociale",
    "ad.co_form": "Forme juridique",
    "ad.co_rccm": "RCCM",
    "ad.co_tax": "N° Impôt / ID Nationale",
    "ad.co_manager": "Gérant",
    "ad.co_address": "Adresse du siège social",
    "ad.co_phone": "Téléphone",
    "ad.co_email": "Email officiel",
    "ad.co_web": "Site web",
    "ad.co_save": "Enregistrer",
    "ad.co_saved": "Société mise à jour",
    "ad.cp_new": "Nouveau coupon",
    "ad.cp_code": "Code",
    "ad.cp_type": "Type",
    "ad.cp_pct": "% Pourcentage",
    "ad.cp_fixed": "€ Montant fixe",
    "ad.cp_value_pct": "Valeur (%)",
    "ad.cp_value_eur": "Valeur (EUR)",
    "ad.cp_min": "Montant minimum (EUR)",
    "ad.cp_max": "Utilisations max",
    "ad.cp_unlimited": "Illimité",
    "ad.cp_valid": "Valide jusqu'au",
    "ad.cp_desc": "Description (interne)",
    "ad.cp_desc_ph": "Ex : Bienvenue nouveaux clients",
    "ad.cp_create": "Créer le coupon",
    "ad.cp_list": "Coupons existants",
    "ad.cp_empty": "Aucun coupon pour l'instant. Créez-en un avec le formulaire à gauche.",
    "ad.cp_min_short": "Min :",
    "ad.cp_uses": "utilisation(s)",
    "ad.cp_inactive": "INACTIF",
    "ad.cp_expires": "Expire le",
    "ad.cp_activate": "Activer",
    "ad.cp_deactivate": "Désactiver",
    "ad.cp_confirm_delete": "Supprimer ce coupon ?",
    "ad.cp_deleted": "Coupon supprimé",
    "ad.cp_created": "créé",
    "ad.cp_activated": "Coupon activé",
    "ad.cp_deactivated": "Coupon désactivé",
    "ad.kyc_queue": "File d'attente",
    "ad.kyc_all": "Tous",
    "ad.kyc_none": "Aucune demande en attente 🎉",
    "ad.kyc_statuses": "Statuts",
    "ad.kyc_pending_badge": "EN ATTENTE",
    "ad.kyc_select_hint": "Sélectionnez un vendeur à gauche pour voir ses documents.",
    "ad.kyc_status": "Statut :",
    "ad.kyc_type": "Type",
    "ad.kyc_type_biz": "Entreprise",
    "ad.kyc_type_ind": "Particulier",
    "ad.kyc_legal_name": "Nom légal",
    "ad.kyc_birth": "Naissance",
    "ad.kyc_phone": "Téléphone",
    "ad.kyc_address": "Adresse",
    "ad.kyc_biz_name": "Nom entreprise",
    "ad.kyc_rccm": "RCCM",
    "ad.kyc_nif": "NIF",
    "ad.kyc_idnum": "N° pièce ID",
    "ad.kyc_payout": "Compte reversement",
    "ad.kyc_id_doc": "Pièce d'identité",
    "ad.kyc_selfie": "Selfie",
    "ad.kyc_proof": "Justificatif",
    "ad.kyc_reason_ph": "Motif (obligatoire pour refuser ou suspendre)",
    "ad.kyc_reason_required": "Motif requis",
    "ad.kyc_approve": "Approuver",
    "ad.kyc_reject": "Refuser",
    "ad.kyc_suspend": "Suspendre",
    "ad.kyc_no_docs": "Ce vendeur n'a pas encore soumis de documents KYC.",
    "ad.kyc_approved": "Vendeur vérifié ✓",
    "ad.kyc_rejected": "Refusé",
    "ad.kyc_suspended": "Suspendu",
    "ad.payouts_hint": "Commandes dont la rétention est passée et qui doivent être reversées aux vendeurs.",
    "ad.payouts_none": "Aucun reversement en attente. Tout est à jour ✓",
    "ad.payouts_paid_on": "Payée le",
    "ad.payouts_total_order": "Total commande",
    "ad.payouts_sale": "Vente",
    "ad.payouts_commission": "Commission",
    "ad.payouts_confirm": "Marquer cette commande comme reversée au vendeur ?",
    "ad.payouts_mark": "Marquer comme reversé",
    "ad.payouts_pay_pawapay": "Payer via Mobile Money (PawaPay)",
    "ad.payouts_pawapay_confirm": "Envoyer automatiquement le paiement au vendeur via son numéro Mobile Money (PawaPay Sandbox) ?",
    "ad.payouts_pawapay_sent": "✅ Payout envoyé au vendeur via PawaPay",
    "ad.payouts_pawapay_partial": "Payout partiel — certains transferts ont échoué",
    "ad.payouts_recorded": "Reversement enregistré",
    "ad.pl_title": "Paramètres marketplace",
    "ad.pl_intro": "Commission SUKANACOOP, délai de rétention, plafond vendeurs non vérifiés.",
    "ad.pl_commission": "Taux de commission SUKANACOOP",
    "ad.pl_commission_hint": "(recommandé 10-15%)",
    "ad.pl_retention": "Rétention avant reversement",
    "ad.pl_retention_hint": "jour(s) après paiement (recommandé 3-7)",
    "ad.pl_maxprod": "Plafond annonces vendeur non vérifié",
    "ad.pl_maxprod_hint": "annonces max tant que non-KYC",
    "ad.pl_save": "Enregistrer",
    "ad.pl_saved": "Paramètres sauvegardés",
  },

  en: {
    // ===== Header =====
    "header.search": "Search a product, service, or seller…",
    "header.search.short": "Search…",
    "header.products": "Products",
    "header.services": "Services",
    "header.categories": "Categories",
    "header.login": "Sign in",
    "header.register": "Sign up",
    "header.profile": "My profile",
    "header.favorites": "My favorites",
    "header.orders": "My orders",
    "header.notifications": "Notifications",
    "header.seller_dashboard": "Seller dashboard",
    "header.admin": "Administration",
    "header.logout": "Sign out",
    "header.country_currency": "Country & currency",
    "header.language": "Language",

    // ===== Home =====
    "home.tag": "MARKETPLACE",
    "home.title.buy": "Buy, sell, offer your",
    "home.title.services": "services",
    "home.title.dash": "— all in one place.",
    "home.subtitle": "SUKANACOOP is the marketplace that connects buyers, sellers and service providers in a modern and secure environment.",
    "home.cta.products": "Explore products",
    "home.cta.providers": "Find a provider",
    "home.badge.payment": "Secure payment",
    "home.badge.delivery": "Pickup & delivery",
    "home.badge.community": "Active community",
    "home.explore": "Explore",
    "home.all_categories": "All categories",
    "home.see_all": "See all",
    "home.new_badge": "New",
    "home.open_shop_title": "Open your shop in 5 minutes",
    "home.open_shop_desc": "Publish your products or services, manage orders and messages from a clear dashboard.",
    "home.become_seller": "Become a seller",
    // ===== Seller Landing =====
    "home.sellers_landing.eyebrow": "SELLERS · FRANCE 🇫🇷 · DRC 🇨🇩",
    "home.sellers_landing.title": "Open your shop in 5 minutes",
    "home.sellers_landing.subtitle": "Join the marketplace connecting the Congolese diaspora with France. List, sell, get paid without a merchant account — we handle it all.",
    "home.sellers_landing.launch_offer": "3 free months on Standard & Pro — Launch offer",
    "home.sellers_landing.benefit.visibility.title": "Instant visibility",
    "home.sellers_landing.benefit.visibility.desc": "Your listings are indexed in our categories, search engine and shop directory the moment you publish.",
    "home.sellers_landing.benefit.commission.title": "Fair commission — 7 to 10%",
    "home.sellers_landing.benefit.commission.desc": "No signup fees. You only pay when you sell. Commission decreases as you upgrade your plan.",
    "home.sellers_landing.benefit.logistics.title": "Turnkey logistics",
    "home.sellers_landing.benefit.logistics.desc": "4 built-in shipping options: pickup, Kinshasa, DRC provinces, international. The customer pays shipping alongside the order.",
    "home.sellers_landing.benefit.instant_pay.title": "Mobile Money payouts",
    "home.sellers_landing.benefit.instant_pay.desc": "Receive your money directly on your Vodacom, Airtel or Orange Money account after the safety period — automatic.",
    "home.sellers_landing.plans_eyebrow": "3 PLANS",
    "home.sellers_landing.plans_title": "Pick the plan that fits your business",
    "home.sellers_landing.see_all_plans": "See all plans",
    "home.sellers_landing.month": "month",
    "home.sellers_landing.plan.free.name": "Free",
    "home.sellers_landing.plan.free.tagline": "5 listings · 10% commission · Discover the platform",
    "home.sellers_landing.plan.standard.name": "Standard",
    "home.sellers_landing.plan.standard.tagline": "50 listings · 10% commission · Active Seller badge · 3 months free",
    "home.sellers_landing.plan.pro.name": "Pro",
    "home.sellers_landing.plan.pro.tagline": "Unlimited · 7% commission · SEO boost · Analytics · 3 months free",
    "home.sellers_landing.cta_hint": "Create your seller account in less than 5 minutes. No credit card required to start.",
    "home.sellers_landing.cta_signup": "🚀 Create my shop for free",
    "home.sellers_landing.cta_see_shops": "See existing shops",
    "home.launch.badge": "🎉 LAUNCH",
    "home.launch.text": "Enjoy",
    "home.launch.code": "LANCEMENT10",
    "home.launch.discount": "for -10% on your first order",
    "home.launch.cta": "Browse deals",
    "home.launch.copy": "Copy code",
    "home.launch.copied": "Code copied!",
    "home.new_arrivals.eyebrow": "✨ Just landed",
    "home.new_arrivals.title": "SUKANACOOP New Arrivals",
    "home.new_arrivals.subtitle": "The latest products and services added to the marketplace.",
    "home.new_arrivals.see_all": "See all",
    "home.featured": "Featured",
    "home.featured_products": "Featured products",
    "home.all_products": "All products",
    "home.highlight": "Highlight",
    "home.featured_services": "Featured services",
    "home.all_services": "All services",
    "home.cat.service": "Service",
    "home.cat.mixed": "Mixed",
    "home.cat.product": "Product",

    // ===== Common =====
    "common.loading": "Loading…",
    "common.save": "Save",
    "common.saving": "Saving…",
    "common.cancel": "Cancel",
    "common.delete": "Delete",
    "common.edit": "Edit",
    "common.apply": "Apply",
    "common.total": "Total",
    "common.subtotal": "Subtotal",
    "common.results": "result(s)",
    "common.explore": "Explore",
    "common.all": "All",
    "common.back": "Back",
    "common.next": "Continue",
    "common.previous": "Previous",
    "common.send": "Send",
    "common.error": "Error",
    "common.create": "Create",
    "common.creating": "Creating…",
    "common.optional": "optional",
    "common.required": "required",
    "common.copy": "Copy",
    "common.copied": "Copied",
    "common.view": "View",
    "common.sending": "Sending…",
    "common.close": "Close",
    "common.yes": "Yes",
    "common.no": "No",
    "common.confirm": "Confirm",

    // ===== Cart =====
    "cart.title": "My cart",
    "cart.empty": "Your cart is empty.",
    "cart.summary": "Summary",
    "cart.coupon.label": "Promo code",
    "cart.coupon.placeholder": "e.g. WELCOME10",
    "cart.payment": "Payment method",
    "cart.pay.mobile": "Mobile Money",
    "cart.pay.wallet_currency": "Mobile Money wallet currency",
    "cart.pay.wallet_currency_hint": "Choose which wallet PawaPay should debit. On Vodacom / Airtel / Orange DRC your account can hold USD and/or CDF — pick the wallet where you have a balance.",
    "cart.pay.debit_in": "Debited in",
    "cart.pay.bank": "Bank transfer",
    "cart.pay.bank.badge": "LARGE AMOUNTS",
    "cart.delivery": "Delivery mode",
    "cart.delivery.pickup": "Pickup in store",
    "cart.delivery.local": "Local delivery",
    "cart.delivery.address": "Address",
    "cart.delivery.address_placeholder": "Number, street, city, area…",
    "cart.shipping_title": "Shipping",
    "cart.shipping_line": "Shipping",
    "cart.shipping_free": "Free",
    "cart.checkout.pawapay": "Pay via Mobile Money",
    "cart.checkout.bank": "Create order & see instructions",
    "cart.terms.pre": "I have read and accept the",
    "cart.terms.link": "Terms of Sale & Refund Policy",
    "cart.terms.post": "of SUKANACOOP.",
    "cart.terms.error": "Please accept the Terms before finalising your order.",
    "cart.clear": "Empty cart",

    // ===== Listings =====
    "listing.products.title": "Products",
    "listing.services.title": "Services",
    "listing.filter.search": "Search",
    "listing.filter.category": "Category",
    "listing.filter.priceMin": "Min price",
    "listing.filter.priceMax": "Max price",
    "listing.filter.city": "City",
    "listing.tab.congo": "Congo (DRC)",
    "listing.tab.france": "France",
    "listing.filter.keyword": "Keyword…",

    // ===== Favorites =====
    "fav.title": "My favorites",
    "fav.guest.title": "Your favorites",
    "fav.guest.subtitle": "Sign in to find your favorite products and services.",
    "fav.empty": "No favorites yet.",
    "fav.empty.hint": "Click the heart ❤️ on products you love to find them here.",
    "fav.explore": "Explore products",
    "fav.section.products": "Products",
    "fav.section.services": "Services",
    "fav.added": "Added to favorites ❤️",
    "fav.removed": "Removed from favorites",
    "fav.login_needed": "Sign in to add favorites",

    // ===== Footer =====
    "footer.marketplace": "Marketplace",
    "footer.sell": "Sell",
    "footer.help_legal": "Help & Legal",
    "footer.description": "The marketplace for products & services, connecting buyers, sellers and providers around the world.",
    "footer.becomeSeller": "Become a seller",
    "footer.dashboard": "Dashboard",
    "footer.legal": "Legal notice",
    "footer.search": "Search",

    // ===== Login =====
    "login.title": "Sign in",
    "login.subtitle": "Welcome back to SUKANACOOP.",
    "login.email": "Email",
    "login.password": "Password",
    "login.forgot": "Forgot password?",
    "login.submit": "Sign in",
    "login.no_account": "No account yet?",
    "login.register": "Sign up",
    "login.loading": "Signing in…",
    "login.error": "Invalid credentials",

    // ===== Register (choice) =====
    "reg.tag": "SUKANACOOP",
    "reg.title": "Join the community",
    "reg.subtitle": "How do you want to use SUKANACOOP? Choose your profile to get started.",
    "reg.buyer_title": "I'm a Buyer",
    "reg.buyer_desc": "I want to buy products or book services offered by SUKANACOOP sellers.",
    "reg.buyer_b1": "Free signup in 1 minute",
    "reg.buyer_b2": "Secure payment (Mobile Money & card)",
    "reg.buyer_b3": "Favorites, orders and messaging",
    "reg.buyer_cta": "Sign up as a Buyer",
    "reg.seller_title": "I'm a Seller / Provider",
    "reg.seller_desc": "I have a shop, I'm an artisan, or I offer a service. I want to sell on SUKANACOOP.",
    "reg.seller_b1": "Open your online shop",
    "reg.seller_b2": "Receive your payments via Mobile Money",
    "reg.seller_b3": "Secure account verification (KYC)",
    "reg.seller_cta": "Become a Seller",
    "reg.earn_badge": "EARN MONEY",
    "reg.already": "Already signed up?",
    "reg.back": "Back to choice",

    // ===== Buyer form =====
    "reg.b.title": "Buyer signup",
    "reg.b.subtitle": "Create your account in 30 seconds.",
    "reg.b.fullname": "Full name",
    "reg.b.email": "Email",
    "reg.b.password": "Password (min. 6 characters)",
    "reg.b.city": "City",
    "reg.b.country": "Country",
    "reg.b.submit": "Create my buyer account",
    "reg.b.loading": "Creating…",
    "reg.b.terms": "By signing up, you accept our",
    "reg.b.terms_link": "Terms",

    // ===== Legacy Register =====
    "reg.legacy.title": "Create an account",
    "reg.legacy.subtitle": "Join the SUKANACOOP community",
    "reg.legacy.iam": "I am",
    "reg.legacy.buyer": "Buyer",
    "reg.legacy.buyer_desc": "Explore and buy",
    "reg.legacy.seller": "Seller / Provider",
    "reg.legacy.seller_desc": "Open a shop",
    "reg.legacy.fullname": "Full name",
    "reg.legacy.email": "Email",
    "reg.legacy.password": "Password",
    "reg.legacy.city": "City",
    "reg.legacy.country": "Country",
    "reg.legacy.submit": "Create my account",
    "reg.legacy.loading": "Creating…",
    "reg.legacy.success": "Account created! A verification email has been sent (mock).",
    "reg.legacy.error": "Signup error",

    // ===== Seller Register wizard =====
    "rs.title": "Become a Seller",
    "rs.step_of": "Step {step} of {total}",
    "rs.step1_label": "Step 1 · Your account",
    "rs.step2_label": "Step 2 · Your shop",
    "rs.step3_label": "Step 3 · Business legal information",
    "rs.account_type": "Account type *",
    "rs.individual": "Individual / Artisan (natural person)",
    "rs.business": "Registered business (RCCM)",
    "rs.change_later": "You can change this later if your status evolves.",
    "rs.responsible_fullname": "Full name of the person in charge *",
    "rs.responsible_placeholder": "First name Last name",
    "rs.email": "Email *",
    "rs.email_placeholder": "you@shop.com",
    "rs.phone": "Phone *",
    "rs.phone_placeholder": "+243 ...",
    "rs.password_min": "Password * (min. 6 characters)",
    "rs.shop_name": "Your shop name *",
    "rs.shop_name_placeholder": "e.g. Miel du Katanga",
    "rs.shop_name_hint": "This name will be visible to buyers.",
    "rs.city": "City *",
    "rs.country": "Country *",
    "rs.address_recommend": "Address (recommended)",
    "rs.address_placeholder": "Number, avenue, district…",
    "rs.what_sell": "What do you sell? (free description)",
    "rs.what_sell_placeholder": "e.g. Artisan honey, Wax textiles, private lessons…",
    "rs.business_name": "Legal business name *",
    "rs.business_name_placeholder": "Name as registered at RCCM",
    "rs.rccm": "RCCM number *",
    "rs.rccm_placeholder": "CD/KIN/RCCM/24-B-...",
    "rs.tax_id": "Tax ID (NIF)",
    "rs.confirmation": "Confirmation & terms",
    "rs.kyc_notice_before": "After signup, you will need to complete",
    "rs.kyc_notice_strong": "KYC verification",
    "rs.kyc_notice_after": "(ID document, selfie) to publish more than 3 listings.",
    "rs.commission_notice_before": "SUKANACOOP charges a",
    "rs.commission_notice_strong": "10% commission",
    "rs.commission_notice_after": "on each sale and releases the balance after 5 days (retention period).",
    "rs.accept_terms_pre": "I accept the",
    "rs.terms_link": "Terms of Sale",
    "rs.accept_terms_post": "and the privacy policy.",
    "rs.accept_commission": "I accept the SUKANACOOP 10% commission and the 5-day retention period.",
    "rs.previous": "Previous",
    "rs.continue": "Continue",
    "rs.create_shop": "Create my shop",
    "rs.creating": "Creating…",
    "rs.err_fill_all": "Please fill in all required fields",
    "rs.err_password_min": "Password min. 6 characters",
    "rs.err_terms": "You must accept the terms.",
    "rs.err_business": "Business name + RCCM required for a business",
    "rs.success": "Seller account created! Complete your KYC verification to start selling.",
    "rs.err_signup": "Signup error",
    "rs.already": "Already signed up?",
    "rs.login": "Sign in",

    // ===== ItemDetail =====
    "item.stock": "In stock",
    "item.out_of_stock": "Out of stock",
    "item.add_to_cart": "Add to cart",
    "item.buy_now": "Buy",
    "item.description": "Description",
    "item.reviews": "Reviews",
    "item.no_reviews": "No reviews yet.",
    "item.write_review": "Write a review",
    "item.publish_review": "Publish",
    "item.rate_label": "Rating",
    "item.review_placeholder": "Your review…",
    "item.seller": "Seller",
    "item.location": "Location",
    "item.contact_seller": "Contact seller",
    "item.quantity": "Quantity",
    "item.category": "Category",
    "item.added_to_cart": "Added to cart",
    "item.product": "Product",
    "item.service": "Service",
    "item.new_no_reviews": "New",
    "item.stock_line": "Stock:",
    "item.stock_available": "available",
    "item.stock_out_text": "sold out",
    "item.service_quote": "Service on quote / to book",
    "item.pay_secure": "🔒 100% secure payment",
    "item.pay_mm_card": "Mobile Money · Card",
    "item.rate_note": "Rating:",
    "item.msg_placeholder": "Send a message to the seller…",
    "item.msg_send": "Send",
    "item.msg_login_required": "Please sign in",
    "item.review_login_required": "Sign in to leave a review",
    "item.review_published": "Review published",
    "item.msg_sent": "Message sent",
    "item.err": "Error",
    "item.book_title": "Book a slot",
    "item.book_pick": "Pick an available time slot:",
    "item.book_no_slots": "No time slot available yet. Contact the provider directly.",
    "item.book_phone": "Your phone number (optional)",
    "item.book_notes": "Notes or special requests (optional)",
    "item.book_confirm": "Confirm booking",
    "item.book_success": "Booking sent — the provider will get in touch",
    "item.book_login_required": "Sign in to book",
    "item.book_pick_slot": "Please pick a slot first",
    "item.book_note": "The provider will contact you to confirm and arrange payment.",

    // ===== Search =====
    "search.title": "Search results",
    "search.no_results": "No results for your search.",
    "search.for": "for",

    // ===== Categories page =====
    "categories.title": "All categories",
    "categories.subtitle": "Browse by product, service or country",

    // ===== Profile =====
    "profile.title": "My profile",
    "profile.name": "Name",
    "profile.email": "Email",
    "profile.phone": "Phone",
    "profile.city": "City",
    "profile.country": "Country",
    "profile.save": "Save",
    "profile.password_section": "Security — password",
    "profile.old_password": "Old password",
    "profile.new_password": "New password",
    "profile.confirm_password": "Confirm",
    "profile.change_password": "Change password",
    "profile.saved": "Profile updated",
    "profile.pw_changed": "Password changed",
    "profile.newsletter_title": "SUKANACOOP Communications",
    "profile.newsletter_active": "You receive our news, restocks and promotions by email.",
    "profile.newsletter_inactive": "Get early access to our new products, restocks and exclusive offers.",
    "profile.newsletter_subscribe": "Subscribe to updates",
    "profile.newsletter_unsubscribe": "Unsubscribe",
    "profile.newsletter_on": "You'll receive SUKANACOOP updates ✨",
    "profile.newsletter_off": "You'll no longer receive our updates",
    "reg.newsletter": "I'd like to receive news, restocks, promotions and offers from SUKANACOOP by email. I can unsubscribe at any time from my account.",

    // ===== Orders =====
    "orders.title": "My orders",
    "orders.empty": "You don't have any order yet.",
    "orders.reference": "Reference",
    "orders.date": "Date",
    "orders.total": "Total",
    "orders.status": "Status",
    "orders.details": "Details",
    "orders.payment": "Payment",
    "orders.paid": "Paid",
    "orders.pending": "Pending",
    "orders.confirmed": "Confirmed",
    "orders.shipped": "Shipped",
    "orders.delivered": "Delivered",
    "orders.cancelled": "Cancelled",
    "orders.invoice": "PDF Invoice",
    "orders.awaiting_transfer": "Awaiting transfer",

    // ===== Refunds (buyer) =====
    "refund.request_cta": "Request a refund",
    "refund.badge_pending": "Refund request under review",
    "refund.badge_approved": "Refund approved",
    "refund.badge_rejected": "Refund request rejected",
    "refund.approved_hint": "in progress — you'll get an email once completed.",
    "refund.rejected_reason": "Reason:",
    "refund.window_expired": "Withdrawal window ({days} days) has expired.",
    "refund.modal_title": "Request a refund",
    "refund.modal_intro": "Let us know the reason — our team processes refund requests within 2 to 5 business days. Refunds are issued via the original payment channel by default.",
    "refund.reason_label": "Reason *",
    "refund.reason_placeholder": "Pick a reason…",
    "refund.reason_defective": "Defective product",
    "refund.reason_not_as_described": "Product not as described",
    "refund.reason_not_delivered": "Order not delivered",
    "refund.reason_missing_item": "Missing item",
    "refund.reason_other": "Other",
    "refund.comment_label": "Comment",
    "refund.comment_label_required": "Explain the reason *",
    "refund.comment_placeholder": "Tell us more about the issue…",
    "refund.payout_label": "Payout details (optional)",
    "refund.payout_placeholder": "IBAN, Mobile Money number or PayPal — only if different from the original payment",
    "refund.payout_hint": "By default we refund via the original payment channel.",
    "refund.submit": "Submit request",
    "refund.submitting": "Sending…",
    "refund.submit_success": "Request sent — you'll receive a confirmation email.",
    "refund.err_reason": "Please pick a reason.",
    "refund.err_other_comment": "Please explain the reason in the comment field.",
    "refund.cancel": "Cancel",
    "refund.modal_close": "Close",

    // ===== KYC / SellerVerification =====
    "kyc.back": "← Back to dashboard",
    "kyc.title": "Seller KYC verification",
    "kyc.intro": "This verification protects buyers and strengthens trust in your shop. Your documents are stored confidentially and will never be published.",
    "kyc.pending_title": "Verification in progress",
    "kyc.pending_desc": "An admin is currently reviewing your documents. You will receive a notification once done.",
    "kyc.verified_title": "Account verified ✓",
    "kyc.verified_desc": "You can publish without limits and receive your payments.",
    "kyc.rejected_title": "Verification refused",
    "kyc.rejected_reason": "Reason:",
    "kyc.rejected_fix": "Please correct the information below and submit again.",
    "kyc.section1": "1. Seller identity",
    "kyc.section2": "2. Address & Location",
    "kyc.section_business": "3. Business information",
    "kyc.section_docs_biz": "4. Supporting documents",
    "kyc.section_docs_ind": "3. Supporting documents",
    "kyc.section_payout_biz": "5. Payout account",
    "kyc.section_payout_ind": "4. Payout account",
    "kyc.seller_type": "Seller type *",
    "kyc.individual": "Individual",
    "kyc.business": "Registered business",
    "kyc.full_legal_name": "Full legal name *",
    "kyc.full_legal_placeholder": "As on the ID document",
    "kyc.dob": "Date of birth *",
    "kyc.phone": "Phone (verifiable) *",
    "kyc.phone_placeholder": "+243 ...",
    "kyc.address": "Physical address *",
    "kyc.address_placeholder": "Number, avenue, district…",
    "kyc.city": "City *",
    "kyc.country": "Country *",
    "kyc.business_name": "Legal business name *",
    "kyc.rccm": "RCCM *",
    "kyc.rccm_placeholder": "e.g. CD/KIN/RCCM/24-B-04135",
    "kyc.tax_id": "Tax ID (NIF)",
    "kyc.id_doc_type": "Document type *",
    "kyc.id_doc_id_card": "Voter / ID card",
    "kyc.id_doc_passport": "Passport",
    "kyc.id_doc_permit": "Driver's licence",
    "kyc.id_doc_number": "Document number *",
    "kyc.upload_id_label": "Photo of the ID document (front/back)",
    "kyc.upload_id_hint": "Clear, sharp, fully visible photo. JPG/PNG/PDF max 5 MB.",
    "kyc.upload_selfie_label": "Selfie with your ID document",
    "kyc.upload_selfie_hint": "Take a photo of yourself holding your document next to your face. This is to prevent identity fraud.",
    "kyc.upload_proof_biz_label": "Photo of RCCM / trade register",
    "kyc.upload_proof_ind_label": "Proof of address (utility bill, etc.)",
    "kyc.upload_proof_biz_hint": "Readable photo of your business official document.",
    "kyc.upload_proof_ind_hint": "Document less than 3 months old in your name.",
    "kyc.file_uploaded": "Document uploaded",
    "kyc.file_upload_fail": "Upload failed",
    "kyc.file_too_big": "File too big (max 5 MB)",
    "kyc.uploading": "Uploading…",
    "kyc.file_replace": "File loaded — click to replace",
    "kyc.drop_file": "Click or drop a file here",
    "kyc.view": "View",
    "kyc.id_doc_view": "ID document",
    "kyc.selfie_view": "Selfie",
    "kyc.proof_view": "Proof",
    "kyc.payout_note_pre": "This account will receive your payments after validation. It must be",
    "kyc.payout_note_strong": "in your name",
    "kyc.payout_note_post": "(not a third party).",
    "kyc.method": "Method *",
    "kyc.method_mm": "Mobile Money (Vodacom / Airtel / Orange)",
    "kyc.method_bank": "Bank transfer",
    "kyc.holder": "Account holder *",
    "kyc.holder_placeholder": "First name + last name exactly",
    "kyc.number_mm": "Mobile Money number *",
    "kyc.number_bank": "Account number / IBAN *",
    "kyc.submit": "Submit for verification",
    "kyc.submitting": "Sending…",
    "kyc.submit_hint": "By submitting, you accept the processing of your personal data according to our Terms.",
    "kyc.err_docs": "ID document + selfie required",
    "kyc.err_rccm": "RCCM required for a business",
    "kyc.sent": "Request sent — you will receive an answer within 24–48h",
    "kyc.err_generic": "Error",

    // ===== BankTransfer =====
    "bt.title": "Transfer instructions",
    "bt.order": "Order",
    "bt.amount": "Amount:",
    "bt.confirmed_banner": "Transfer confirmed — your order is being prepared.",
    "bt.beneficiary": "Transfer beneficiary",
    "bt.accounts": "Bank accounts",
    "bt.transfer_instruction": "Transfer to one of the accounts below.",
    "bt.reference_required_pre": "You must include the reference",
    "bt.reference_required_post": "in the wire description.",
    "bt.account_number": "Account no.",
    "bt.iban": "IBAN",
    "bt.swift": "SWIFT",
    "bt.currency": "Currency",
    "bt.send_proof_title": "Send proof of transfer",
    "bt.send_proof_desc": "Once the transfer is done, upload a screenshot or PDF of the receipt. The seller will validate your order within 24h.",
    "bt.file_label": "File (photo or PDF)",
    "bt.ref_optional": "Bank reference (optional)",
    "bt.ref_placeholder": "e.g. TXN-2026-08-0001",
    "bt.note_optional": "Note (optional)",
    "bt.note_placeholder": "Extra info for the seller…",
    "bt.send_proof": "Send proof",
    "bt.sending": "Sending…",
    "bt.proof_sent": "Proof sent. The seller will verify your transfer.",
    "bt.select_file": "Select a proof file",
    "bt.awaiting_title": "✓ Proof sent",
    "bt.awaiting_desc": "Your proof is being reviewed by the seller. You will get a notification as soon as they confirm.",
    "bt.see_orders": "See my orders →",
    "bt.copied": "Copied",
    "bt.connect": "Please sign in…",

    // ===== Payment =====
    "pay.verify": "Verifying payment…",
    "pay.confirmed": "Payment confirmed",
    "pay.confirmed_desc": "Thanks for your order. Your receipt has been saved.",
    "pay.pawapay_confirmed_desc": "Thank you! Your Mobile Money order has been accepted.",
    "pay.my_orders": "My orders",
    "pay.home": "Home",
    "pay.pending_title": "Payment pending",
    "pay.pending_desc": "We didn't confirm your payment in time. Check your orders.",
    "pay.pending_desc_pp": "We didn't confirm your payment in time. Check your orders or try again.",
    "pay.cancelled_title": "Payment cancelled",
    "pay.cancelled_desc": "Your order has not been finalised.",
    "pay.back_cart": "Back to cart",
    "pay.verify_mm": "Verifying Mobile Money…",
    "pay.verify_mm_desc": "We are confirming your payment with PawaPay.",

    // ===== Invoice =====
    "inv.print": "Print / PDF",
    "inv.title": "INVOICE",
    "inv.number": "No.",
    "inv.issued_on": "Issued on",
    "inv.paid": "PAID",
    "inv.pending": "PENDING",
    "inv.marketplace_by": "Marketplace operated by",
    "inv.emitter": "Issuer",
    "inv.emitter_operated_by": "Operated by",
    "inv.emitter_note": "Billing handled by SUKANACOOP on behalf of the seller (marketplace).",
    "inv.customer": "Customer",
    "inv.rccm": "RCCM:",
    "inv.tax_id": "Nat. ID:",
    "inv.designation": "Description",
    "inv.qty": "Qty",
    "inv.unit_price": "U.P.",
    "inv.total": "Total",
    "inv.product": "Product",
    "inv.service": "Service",
    "inv.subtotal": "Subtotal",
    "inv.total_ttc": "Total (incl. tax)",
    "inv.shipping": "Shipping",
    "inv.coupon": "Discount",
    "inv.pay_method": "Payment method:",
    "inv.pay_bank_ref": "Bank transfer (ref.",
    "inv.pay_pawapay": "Mobile Money / Card via PawaPay",
    "inv.pay_card": "Bank card (Stripe)",
    "inv.no_vat": "VAT not applicable, article 293 B of the CGI (DRC).",
    "inv.thanks_pre": "Thank you for your purchase on",
    "inv.thanks_marketplace": "SUKANACOOP, the marketplace operated by",

    // ===== Legal notice =====
    "legal.info": "Legal information",
    "legal.title": "Legal notice",
    "legal.editor": "Site editor",
    "legal.edited_by_pre": "The",
    "legal.edited_by_mid": "site is published and operated by",
    "legal.legal_form": "Legal form",
    "legal.rccm": "RCCM",
    "legal.tax_id": "Tax ID / Nat. ID",
    "legal.hq": "Head office",
    "legal.phone": "Phone",
    "legal.email": "Email",
    "legal.manager": "Manager",
    "legal.purpose": "Purpose of the site",
    "legal.purpose_desc_pre": "SUKANACOOP is an online marketplace connecting buyers, sellers of products and providers of services. Transactions are operated by",
    "legal.hosting": "Hosting",
    "legal.hosting_desc": "The site is hosted on the Emergent cloud infrastructure.",
    "legal.payments": "Payments & billing",
    "legal.payments_desc_pre": "Payments are processed via",
    "legal.payments_desc_mid": "(Mobile Money & bank card) or by",
    "legal.payments_desc_end": "on the accounts of",
    "legal.payments_invoices_pre": "All invoices related to transactions are issued in the name of",
    "legal.contact": "Contact",
    "legal.contact_desc_pre": "For any question, complaint or request for information, contact us at",
    "legal.contact_desc_or": "or at",
    "legal.bank_transfer": "bank transfer",
    "legal.pawapay": "PawaPay",

    // ===== CGV / Refund policy =====
    "cgv.category": "Terms & Refunds",
    "cgv.title": "Terms of Sale & Refund Policy",
    "cgv.last_update": "Last updated",
    "cgv.intro_pre": "is a marketplace operated by",
    "cgv.intro_post": "These Terms of Sale (T&Cs) govern any order placed on SUKANACOOP by a buyer (individual or business).",
    "cgv.footer.link": "Terms & Refunds",

    "cgv.s1_title": "1. Purpose",
    "cgv.s1_p1": "SUKANACOOP is an online marketplace allowing independent sellers and SUKANACOOP itself to offer products and services to buyers. SUKANACOOP acts as a technical intermediary and processes payments on behalf of sellers.",
    "cgv.s1_p2": "By placing an order, the buyer acknowledges having read and unreservedly accepted these T&Cs.",

    "cgv.s2_title": "2. Order & contract",
    "cgv.s2_p1": "The sales contract is formed as soon as payment is validated. An order may include:",
    "cgv.s2_li1": "one or more products sold by a seller registered on the marketplace,",
    "cgv.s2_li2": "one or more services offered by a registered provider,",
    "cgv.s2_li3": "products sold directly by the official SUKANACOOP shop.",

    "cgv.s3_title": "3. Prices, currencies and taxes",
    "cgv.s3_p1": "Prices are displayed in EUR, USD or CDF depending on the buyer's preference. The exchange rate is updated by SUKANACOOP. The price paid is the one in effect at the time of the order.",
    "cgv.s3_p2": "Orders are issued from the DRC: VAT is not applicable (article 293 B of the French Tax Code — DRC regime). Any import customs duties remain the buyer's responsibility.",

    "cgv.s4_title": "4. Payment methods",
    "cgv.s4_p1": "Payments are secured and processed by approved providers:",
    "cgv.s4_transfer": "Bank transfer",
    "cgv.s4_transfer_desc": "to the operator company's accounts (Rawbank, Equity BCDC, TMB). Proof of transfer to be uploaded from the tracking page.",
    "cgv.s4_p2": "The order is only confirmed and forwarded to the seller once payment has been effectively confirmed.",

    "cgv.s5_title": "5. Delivery & availability",
    "cgv.s5_p1": "After payment, SUKANACOOP has 6 hours to confirm order availability with the seller (statuses: Available / Available later / Out of stock). The buyer is notified by email at each step.",
    "cgv.s5_p2": "Shipping fees are shown at checkout (Free pickup, Kinshasa, DRC provinces, International). Estimated timelines depend on the chosen carrier and destination.",

    "cgv.s6_summary_title": "In a nutshell",
    "cgv.s6_summary_li1": "France: refund request possible within 14 days of delivery.",
    "cgv.s6_summary_li2": "DRC & other countries: within 7 days of delivery.",
    "cgv.s6_summary_li3": "Request processed within 5 business days, refund via the original payment channel.",

    "cgv.s6_h1": "6.1 Right of withdrawal",
    "cgv.s6_p1": "In accordance with article L221-18 of the French Consumer Code, buyers residing in France have 14 calendar days from the receipt of the item to exercise their right of withdrawal, without having to give a reason or bear penalties (excluding return costs). For buyers residing in the DRC and other countries where local law does not provide for a mandatory withdrawal period, SUKANACOOP voluntarily applies a commercial period of 7 calendar days.",

    "cgv.s6_h2": "6.2 How to request a refund",
    "cgv.s6_inapp_title": "Recommended method — from /commandes (2 clicks)",
    "cgv.s6_inapp_desc": "From your buyer account, open",
    "cgv.s6_inapp_link": "My orders",
    "cgv.s6_inapp_desc_after": ", pick the relevant order and click the \"Request a refund\" button that appears on every paid order under 14 days old.",
    "cgv.s6_inapp_step1": "Pick a reason from the list (defective product, not as described, not delivered, missing item, or other) and add a short comment to describe your situation.",
    "cgv.s6_inapp_step2": "You'll receive an acknowledgement email within minutes. Our team reviews the request within 2 to 5 business days.",
    "cgv.s6_inapp_step3": "Once approved, the refund is processed automatically via the original payment channel (PawaPay Mobile Money or bank transfer). You'll receive a confirmation email.",
    "cgv.s6_email_fallback_title": "Alternative — by email",
    "cgv.s6_p2": "You can also reach out to us directly:",
    "cgv.s6_step1_pre": "Send an email to",
    "cgv.s6_step1_post": "with the subject \"Refund request\", stating the order number, the reason and your account email address.",
    "cgv.s6_step2": "Our team acknowledges receipt within 24 business hours and confirms the eligibility of your request.",
    "cgv.s6_step3": "Our team reviews your request within 2 to 5 business days and confirms the decision by email.",
    "cgv.s6_step4": "Once approved, the refund is processed automatically via the original payment channel (PawaPay Mobile Money or bank transfer). You'll receive a confirmation email as soon as it is executed.",
    "cgv.s6_return_note": "📦 Product return — A physical return is only required in specific cases (defect dispute, quality contestation, item requiring inspection). In those cases, our team will send you a dedicated return address and instructions separately; the refund timeline then starts once we receive the parcel.",

    "cgv.s6_h3": "6.3 Refund channel",
    "cgv.s6_ch_pawapay": "PawaPay Mobile Money — automatic refund on the mobile number used at payment.",
    "cgv.s6_ch_transfer": "Bank transfer — refund to the original transfer account (or any other account provided by the buyer with prior agreement).",

    "cgv.s6_h4": "6.4 Special cases & exclusions",
    "cgv.s6_p4": "Some goods or services are not eligible for refund, in accordance with article L221-28 of the French Consumer Code:",
    "cgv.s6_excl1": "services fully performed before the end of the withdrawal period, with the buyer's prior consent,",
    "cgv.s6_excl2": "personalised, perishable or unsealed goods for hygiene reasons,",
    "cgv.s6_excl3": "travel, accommodation or catering services on a fixed date.",

    "cgv.s7_title": "7. Legal warranty of conformity",
    "cgv.s7_p1": "Buyers benefit from the legal warranty of conformity and the warranty against hidden defects provided by articles L217-4 et seq. of the French Consumer Code, or by the applicable local law. If a product is defective or non-compliant, contact us by email within the legal deadlines.",

    "cgv.s8_title": "8. Liability & complaints",
    "cgv.s8_p1": "SUKANACOOP does its utmost to ensure the reliability of the marketplace but cannot be held liable for delays beyond its control (carriers, force majeure). In case of a dispute with a seller, the buyer can open a claim from their order; our team will step in to find an amicable solution.",

    "cgv.s9_title": "9. Personal data protection",
    "cgv.s9_p1": "Your data is processed in accordance with the General Data Protection Regulation (GDPR) and Congolese law n°20/017 on telecommunications. You may request access, correction or deletion of your data at any time by email. See also our Legal notice page.",

    "cgv.s10_title": "10. Contact",
    "cgv.s10_p1": "For any question about these T&Cs or a refund request, contact our SUKANACOOP team:",
    "cgv.phone_label": "Phone",
    "cgv.chat_hint": "Chat bubble at the bottom right of the site (quick reply during working hours).",

    "cgv.footer_note_pre": "These T&Cs are governed by Congolese law for transactions processed by",
    "cgv.footer_note_post": "Any dispute shall, failing an amicable settlement, be brought before the competent courts of Kinshasa (DRC) — without prejudice to the mandatory provisions applicable to consumer buyers in their country of residence.",

    // ===== Notifications =====
    "notif.title": "Notification centre",
    "notif.back": "Back",
    "notif.unread": "unread",
    "notif.total": "total",
    "notif.all_read": "All caught up ✓",
    "notif.mark_all_read": "Mark all as read",
    "notif.mark_read": "Mark read",
    "notif.marked_read": "notifications marked as read",
    "notif.empty_title": "No notifications",
    "notif.empty_desc": "You will be notified here for every new order, confirmed payment, KYC decision or payout.",

    // ===== GDPR (Export + Deletion) — EN =====
    "rgpd.section_title": "Privacy & personal data",
    "rgpd.section_desc": "Under GDPR (Articles 17 & 20), you can download all your personal data or delete your account at any time.",
    "rgpd.export_title": "Download my data (JSON)",
    "rgpd.export_desc": "Get a JSON file with your profile, orders, reviews, messages, subscriptions and preferences.",
    "rgpd.export_cta": "Download my data",
    "rgpd.export_success": "Your export has been downloaded ✓",
    "rgpd.delete_title": "Delete my account",
    "rgpd.delete_desc": "Permanently anonymises your account. Invoices & payments are kept (legal duty) but dissociated from your personal profile.",
    "rgpd.delete_cta": "Delete my account",
    "rgpd.delete_success": "Your account has been deleted. Goodbye.",
    "rgpd.modal_title": "Confirm account deletion",
    "rgpd.modal_desc": "This action is irreversible. Once confirmed, you will no longer be able to log in with this email.",
    "rgpd.modal_kept": "Kept: orders, invoices, payouts (10-year accounting duty, France/DRC)",
    "rgpd.modal_erased": "Erased: KYC docs, messages, favourites, notifications, cart, preferences",
    "rgpd.modal_login": "Definitive re-login block on this email",
    "rgpd.modal_confirm_label": "Type DELETE to confirm",
    "rgpd.modal_password_label": "Confirm your password *",
    "rgpd.modal_reason_label": "Reason (optional)",
    "rgpd.modal_reason_placeholder": "Help us improve SUKANACOOP…",
    "rgpd.modal_confirm_cta": "Delete permanently",

    // ===== Cookies (GDPR banner) =====
    "cookies.banner_title": "🍪 You're on SUKANACOOP",
    "cookies.banner_desc": "We use strictly-necessary cookies (cart, session, language). No analytics or advertising cookie is active without your consent.",
    "cookies.accept_all": "Accept all",
    "cookies.refuse_all": "Refuse all",
    "cookies.configure": "Customise",
    "cookies.save_choices": "Save my choices",
    "cookies.learn_more": "Learn more",
    "cookies.footer_link": "Manage cookies",
    "cookies.config_title": "Cookie preferences",
    "cookies.config_desc": "Pick precisely which categories of cookies you allow. Strictly-necessary cookies cannot be disabled (they run the site).",
    "cookies.cat_necessary_title": "Strictly necessary (always on)",
    "cookies.cat_necessary_desc": "Essential cookies: login session, shopping cart, language & currency choice. Without them, SUKANACOOP cannot function. Consent-exempt (CNIL).",
    "cookies.cat_analytics_title": "Anonymous audience measurement",
    "cookies.cat_analytics_desc": "Let us understand how you use the site to improve it (no personal data sold). No such tool is currently active.",
    "cookies.cat_marketing_title": "Advertising & personalisation",
    "cookies.cat_marketing_desc": "Cookies used to show you relevant offers or for retargeting on other sites. No such tool is currently active.",

    // ===== France plans launch waitlist =====
    "sub.fr.section_title": "🇫🇷 France Plans — Coming soon",
    "sub.fr.section_desc": "French shops will soon be able to subscribe to SUKANACOOP plans in EUR. Sign up to be notified at launch.",
    "sub.fr.notify_cta": "🔔 Notify me at launch",
    "sub.fr.coming_soon": "Coming soon",
    "sub.fr.audit_note": "Fiscal & legal review in progress",
    "sub.fr.modal_title": "Get notified about France plans launch",
    "sub.fr.modal_desc": "Leave your contact details — we'll email you as soon as France plans go live.",
    "sub.fr.form_email": "Email",
    "sub.fr.form_name": "First / Last name",
    "sub.fr.form_company": "Your shop name (optional)",
    "sub.fr.form_plan": "Plan you're interested in",
    "sub.fr.form_note": "A message for us (optional)",
    "sub.fr.form_submit": "Add me to the waiting list",
    "sub.fr.form_success": "Thanks! We'll let you know as soon as we launch.",
    "sub.fr.form_already": "You're already on this waiting list ✓",

    // ===== Messages =====
    "msg.title": "Messaging",
    "msg.no_conv": "No conversation.",
    "msg.select": "Select a conversation",
    "msg.user": "User",
    "msg.placeholder": "Your message…",
    "msg.send": "Send",

    // ===== Forgot password =====
    "fp.title": "Forgot password",
    "fp.desc": "Enter your email to receive a reset link.",
    "fp.email": "Email",
    "fp.send": "Send",
    "fp.new_title": "New password",
    "fp.token": "Token",
    "fp.new_pw": "New password",
    "fp.reset": "Reset",
    "fp.pw_changed": "Password changed",
    "fp.login_link": "Sign in",
    "fp.email_sent": "If the account exists, an email has been sent (mock).",
    "fp.debug_prefill": "Debug token pre-filled",
    "fp.reset_success": "Password reset! You can now sign in.",
    "fp.err": "Error",

    // ===== Seller Dashboard =====
    "sd.title": "Seller dashboard",
    "sd.verified": "Account verified",
    "sd.pending_verif": "Verification in progress",
    "sd.verify_cta": "Verify my account",
    "sd.correct_verif": "Fix my verification",
    "sd.verif_refused": "Verification refused",
    "sd.verif_required": "Verification required",
    "sd.verif_reason": "Reason:",
    "sd.verif_help_pre": "Complete your KYC verification to publish more than",
    "sd.verif_help_post": "listings and receive your payments.",
    "sd.verif_correct_hint": ". Please fix and resubmit.",
    "sd.suspended": "Account suspended",
    "sd.suspended_contact": "Contact the administrator for more information.",
    "sd.start": "Start",
    "sd.stat_products": "Products",
    "sd.stat_services": "Services",
    "sd.stat_orders": "Orders",
    "sd.stat_revenue": "Revenue",
    "sd.tab_products": "Products",
    "sd.tab_services": "Services",
    "sd.tab_orders": "Orders",
    "sd.tab_revenue": "Revenue",
    "sd.new_product": "New product",
    "sd.new_service": "New service",
    "sd.count_products": "product(s)",
    "sd.count_services": "service(s)",
    "sd.no_orders": "No orders.",
    "sd.stock": "Stock:",
    "sd.proof_received": "📎 Transfer proof received",
    "sd.view_proof": "See proof",
    "sd.confirm_transfer": "✓ Confirm transfer",
    "sd.confirm_transfer_prompt": "Confirm you have received the transfer?",
    "sd.transfer_confirmed": "Transfer confirmed — buyer notified",
    "sd.status_updated": "Status updated",
    "sd.deleted": "Deleted",
    "sd.confirm_delete": "Delete?",
    "sd.pending_days_pre": "Pending",
    "sd.available": "Available",
    "sd.paid_out": "Already released",
    "sd.commission_note": "SUKANACOOP commission:",
    "sd.retention": "Retention:",
    "sd.days_after": "days after payment",
    "sd.no_paid_orders": "No paid orders yet.",
    "sd.sale": "Sale",
    "sd.commission": "Commission",
    "sd.net": "Net",
    "sd.paid_out_badge": "Released",
    "sd.to_release": "To release",
    "sd.blocked_until": "Blocked",
    "sd.tab_shop": "Shop",
    "sd.shop_placeholder": "Your shop",
    "sd.shop_logo": "Logo (square, 200×200 recommended)",
    "sd.shop_logo_hint": "Displayed on your shop page and listings.",
    "sd.shop_cover": "Cover photo (wide, 1200×400 recommended)",
    "sd.shop_cover_hint": "Banner shown on top of your shop and on /boutiques.",
    "sd.shop_name": "Shop name",
    "sd.shop_desc": "About your shop",
    "sd.shop_desc_placeholder": "Tell buyers who you are, what you sell, your story…",
    "sd.shop_location": "City / region",
    "sd.shop_save": "Save my shop",
    "sd.shop_saved": "Shop updated ✓",
    "sd.shop_published_on": "Shop published",
    "sd.shop_published_off": "Shop paused",
    "sd.shop_published_hint_on": "Your shop and listings are visible to all buyers.",
    "sd.shop_published_hint_off": "Your shop and listings are hidden. You can reactivate anytime.",
    "sd.subscription_link": "My subscription",

    // ===== Shop Detail (EN) =====
    "shop.not_found_title_EN_dupe_removed": "",

    // ===== Personal Shopper (EN) =====
    "nav.personal_shopper": "Personal Shopper",
    "ps.eyebrow": "International purchase concierge",
    "ps.title_line1": "Shop everywhere,",
    "ps.title_line2": "we take care of the rest.",
    "ps.subtitle": "Want to buy products from trusted stores in Europe or Congo but can't travel or the shop doesn't deliver to your country? SUKANACOOP Personal Shopper buys for you and delivers to your door.",
    "ps.cta_start": "Make a request",
    "ps.cta_how": "How it works",
    "ps.how_eyebrow": "PROCESS",
    "ps.how_title": "5 simple steps, zero stress",
    "ps.step.send_refs.title": "1. Send your references",
    "ps.step.send_refs.desc": "Product links or shop name",
    "ps.step.receive_quote.title": "2. Get a quote",
    "ps.step.receive_quote.desc": "Within 24-48h, transparent and detailed",
    "ps.step.we_buy.title": "3. We buy",
    "ps.step.we_buy.desc": "After your approval and payment",
    "ps.step.we_ship.title": "4. Pack & ship",
    "ps.step.we_ship.desc": "Real-time parcel tracking",
    "ps.step.delivered.title": "5. Delivered",
    "ps.step.delivered.desc": "To the address you provided",
    "ps.where_eyebrow": "SECTORS",
    "ps.where_title": "Where do we shop for you?",
    "ps.where_desc": "Trusted brands in Europe and Congo, subject to availability and import regulations.",
    "ps.cat.fashion": "Fashion & Accessories",
    "ps.cat.beauty": "Beauty & Cosmetics",
    "ps.cat.baby": "Baby Products",
    "ps.cat.electronics": "Electronics",
    "ps.cat.home": "Home & Decor",
    "ps.cat.sport": "Sports",
    "ps.cat.auto": "Auto parts",
    "ps.cat.cleaning": "Cleaning products",
    "ps.cat.food": "Food",
    "ps.commit_eyebrow": "OUR COMMITMENTS",
    "ps.commit_title": "You're in good hands",
    "ps.commit.trusted_brands": "Purchases from trusted brands",
    "ps.commit.transparent": "Full price transparency",
    "ps.commit.quote_first": "Quote before every order",
    "ps.commit.tracking": "Parcel tracking",
    "ps.commit.personal_support": "Personalized support",
    "ps.pricing_title": "Transparent pricing",
    "ps.pricing_desc": "The total is communicated before any validation. You only pay if you accept the quote.",
    "ps.fee.products": "Product price",
    "ps.fee.service_fee": "Personal Shopper fee",
    "ps.fee.packaging": "Packaging if needed",
    "ps.fee.shipping": "Shipping by country",
    "ps.pricing_footnote": "Free quote, no commitment.",
    "ps.form_eyebrow": "CUSTOM REQUEST",
    "ps.form_title": "Make a request",
    "ps.form_subtitle": "Fill out the form below — our team will reply within 24-48h with a detailed quote.",
    "ps.f.name": "Full name",
    "ps.f.email": "Email",
    "ps.f.phone": "Phone (WhatsApp preferred)",
    "ps.f.country": "Delivery country",
    "ps.f.link": "Product link or shop name",
    "ps.f.link_hint": "If you have no link, describe the product precisely below.",
    "ps.f.description": "Product description",
    "ps.f.description_placeholder": "Brand, model, color, size, technical specs…",
    "ps.f.quantity": "Quantity",
    "ps.f.budget": "Approximate budget",
    "ps.f.photo": "Product photo (optional)",
    "ps.f.comments": "Comments or special requests",
    "ps.f.comments_placeholder": "Deadline, acceptable alternatives, questions…",
    "ps.submit": "Send my request",
    "ps.submit_hint": "No payment required. You only validate after receiving the quote.",
    "ps.required_fields": "Please fill in the required fields (*)",
    "ps.submitted": "✅ Your request has been sent",
    "ps.uploading": "Uploading…",
    "ps.photo_added": "Photo added ✓",
    "ps.photo_fail": "Photo upload failed",
    "ps.thanks_title": "Thanks! We've received your request 🙏",
    "ps.thanks_desc": "Our SUKANACOOP Personal Shopper team will check product availability and send you a personalized quote within 24-48 business hours. You'll receive an instant confirmation email, then the full quote as soon as it's ready.",
    "ps.new_request": "Make another request",

    // Personal Shopper — Quote calculator
    "psq.eyebrow": "CALCULATOR",
    "psq.title": "Estimate your order cost",
    "psq.subtitle": "An instant quote, no commitment. You only confirm if the price works for you.",
    "psq.tab_quote": "Quote",
    "psq.tab_settings": "Parameters",
    "psq.tbd": "TBD",
    "psq.scenario": "Order type",
    "psq.f_name": "Full name",
    "psq.f_email": "Email",
    "psq.f_phone": "Phone",
    "psq.f_country": "Country",
    "psq.order_details": "Order details",
    "psq.f_amount": "Purchase amount",
    "psq.f_weight": "Weight",
    "psq.f_zone": "Delivery zone (Kinshasa)",
    "psq.f_destination": "Delivery destination",
    "psq.france_tbd": "Congo → France rate not defined yet. The quote will show $0 delivery — our team will confirm the exact rate within 24-48h.",
    "psq.download_pdf": "Download quote (PDF)",
    "psq.p_france_freight": "Congo → France freight / kg",

    // Notify me — back-in-stock
    "notifyme.title": "Notify me when back in stock",
    "notifyme.desc": "Leave us your email and we'll ping you as soon as this product is available again.",
    "notifyme.name_ph": "Your first name (optional)",
    "notifyme.email_ph": "email@example.com",
    "notifyme.cta": "Alert me when back",
    "notifyme.sending": "Sending…",
    "notifyme.ok": "Perfect — we'll notify you when it's back",
    "notifyme.already": "You're already on the list — we'll notify you",
    "notifyme.err_email": "Email required",
    "notifyme.done_title": "Alert enabled",
    "notifyme.done_desc": "You'll receive an email as soon as this product is back in stock.",
    "psq.f_notes": "Note or details",
    "psq.f_notes_ph": "Product link, brand, size, reference…",
    "psq.summary": "Summary",
    "psq.r_products": "Product purchase",
    "psq.r_commission": "Commission",
    "psq.r_freight": "Freight",
    "psq.r_delivery": "Delivery",
    "psq.r_total": "Total",
    "psq.submit": "Get my quote",
    "psq.sent": "Quote sent",
    "psq.err_required": "Name and email required",
    "psq.err_amount": "Purchase amount required",
    "psq.err_inactive": "This scenario is not yet available",
    "psq.disclaimer": "Indicative estimate — final price confirmed within 24-48h.",
    "psq.your_quote": "Your quote",
    "psq.success_desc": "We've emailed your quote. Our team will contact you within 24-48h to confirm and place your order.",
    "psq.new_quote": "New quote",
    "psq.load_fail": "Failed to load parameters",
    "psq.p_usd_eur": "USD → EUR",
    "psq.p_usd_cdf": "USD → CDF",
    "psq.p_freight": "Freight / kg",
    "psq.p_tiers": "COMMISSION TIERS",
    "psq.p_tiers_title": "SUKANACOOP commission on your purchase",
    "psq.p_col_range": "Purchase amount ($)",
    "psq.p_col_pct": "SUKANACOOP commission",
    "psq.and_more": "and up",
    "psq.p_zones": "KINSHASA DELIVERY",
    "psq.p_zones_title": "Delivery fees by zone (CDF)",
    "psq.p_scenarios": "ORDER SCENARIOS",
    "psq.p_scenarios_title": "Where we operate",

    // ===== Subscription page =====
    "sub.title": "Seller subscriptions",
    "sub.subtitle": "Pick the plan that fits your business. Cancel anytime. No commitment.",
    "sub.back": "Back to dashboard",
    "sub.promo_title": "🎁 3 free months for launch",
    "sub.promo_desc": "Try Standard or Pro at no cost. After the trial, billing starts automatically. Cancel anytime.",
    "sub.current_plan": "Your current plan",
    "sub.commission": "Current commission:",
    "sub.listings_used": "listings published",
    "sub.trial_active": "Free trial active — enjoy all features",
    "sub.will_cancel": "Cancellation scheduled at the end of the current period",
    "sub.cancel_btn": "Cancel",
    "sub.cancel_confirm": "Cancel your subscription? You'll keep your benefits until the end of the current period.",
    "sub.cancel_scheduled": "Cancellation scheduled",
    "sub.popular": "Most popular",
    "sub.month": "month",
    "sub.trial_days": "free trial days",
    "sub.your_plan": "Your current plan",
    "sub.choose_plan": "Choose this plan",
    "sub.default_plan": "Default plan",
    "sub.downgrade_at_end": "Downgrade to free",
    "sub.activated": "Subscription activated! 🎉",
    "sub.cancelled": "Purchase cancelled — nothing charged",
    "sub.faq_1_q": "Can I change plan?",
    "sub.faq_1_a": "Yes, anytime. The new plan applies at the next billing period.",
    "sub.faq_2_q": "What happens after the 3 free months?",
    "sub.faq_2_a": "Billing starts automatically at the displayed price. You can cancel anytime before.",
    "sub.faq_3_q": "How are prices billed?",
    "sub.faq_3_a": "Prices are in USD, billed monthly via Stripe. Payment is secure (SSL, PCI-DSS).",
    "sd.import_csv": "Import CSV",
    "sd.csv_dialog_title": "Bulk import via CSV",
    "sd.csv_format": "Expected format (first row = headers):",
    "sd.csv_hint": "Separator: comma (,) or semicolon (;). Encoding: UTF-8.",
    "sd.csv_images_hint": "'images' field: URLs separated by a vertical bar |",
    "sd.csv_file": "CSV file",
    "sd.csv_pick_file": "Pick a CSV file first",
    "sd.csv_import_btn": "Run import",
    "sd.csv_importing": "Importing…",
    "sd.csv_imported": "listing(s) created",
    "sd.csv_created": "created",
    "sd.csv_skipped": "skipped",

    // ===== Item form =====
    "if.title": "Title",
    "if.description": "Description",

    // ===== Chatbot =====
    "chat.title": "SUKANACOOP Assistant",
    "chat.subtitle": "Online · replies in seconds",
    "chat.greeting": "Hi there! 👋 I'm the SUKANACOOP assistant. How can I help you today?",
    "chat.placeholder": "Type your message…",
    "chat.thinking": "Assistant is thinking…",
    "chat.open": "Open chat",
    "chat.close": "Close",
    "chat.error": "I'm having trouble. Please try again or reach us on WhatsApp.",
    "whatsapp.label": "Contact us on WhatsApp",
    "whatsapp.greeting": "Hi SUKANACOOP, I have a question:",

    // ===== Directory (Shops & providers) =====
    "dir.title": "Our shops & providers",
    "dir.subtitle": "Discover all our verified sellers and service providers across France and the DRC.",
    "dir.header_link": "Shops",
    "dir.official": "Official",
    "dir.stat_products": "product(s)",
    "dir.stat_services": "service(s)",
    "dir.visit": "Visit shop",
    "dir.empty": "No shops published yet.",
    "dir.search": "Search a shop…",
    "dir.filter_all": "All",
    "dir.filter_products": "Shops (products)",
    "dir.filter_services": "Providers (services)",
    "dir.count": "shop(s) & provider(s)",
    "dir.joined": "Joined in",
    "if.en_toggle_hide": "Hide English version",
    "if.en_toggle_show": "Add / edit English version",
    "if.en_hint": "Optional — if empty, the translation will be generated automatically the first time an English-speaking customer visits.",
    "if.title_en": "Title (EN)",
    "if.description_en": "Description (EN)",
    "if.auto_translate": "🤖 Auto-translate",
    "if.translating": "Translating…",
    "if.translated": "Translation generated",
    "if.translate_fill_first": "Please fill in the French title and description first",
    "if.prices": "Prices per currency",
    "if.price_note": "EUR is the reference price. USD and CDF are displayed according to the currency chosen by the buyer.",
    "if.stock": "Stock",
    "if.category": "Category",
    "if.choose": "Choose…",
    "if.zone": "Geographic zone",
    "if.location": "Location",
    "if.images": "Images",
    "if.image_url": "Or paste a URL:",
    "if.image_added": "Image added",
    "if.upload_fail": "Upload failed",
    "if.save": "Save",
    "if.cancel": "Cancel",
    "if.updated": "Updated",
    "if.created": "Created",
    "if.error": "Error",
    "if.new": "New",
    "if.edit": "Edit",
    "if.product": "product",
    "if.service": "service",
    "if.booking_enable": "Enable time-slot booking",
    "if.booking_duration": "Slot duration",
    "if.booking_add_slot": "Add an available slot",
    "if.booking_add": "Add",
    "if.booking_pick_first": "Please pick a date/time first",
    "if.booking_dup": "This slot is already in the list",
    "if.booking_slots_count": "slot(s) available",
    "if.booking_hint": "Buyers will be able to book one of these slots directly from the service page.",

    // ===== Admin Dashboard =====
    "ad.title": "Administration",
    "ad.stat_users": "Users",
    "ad.stat_products": "Products",
    "ad.stat_orders": "Orders",
    "ad.stat_revenue": "Revenue",
    "ad.stat_revenue_30d": "Revenue · 30 days",
    "ad.stat_commission": "Commission (est.)",
    "ad.stat_paid_orders": "paid orders",
    "ad.stat_active_sellers": "Active sellers",
    "ad.stat_verified_sellers": "KYC verified",
    "ad.stat_payouts_due": "Payouts due (released)",
    "ad.stat_held": "Held",
    "ad.stat_paying_subs": "Paying subscriptions",
    "ad.stat_trialing": "on free trial",
    "ad.stat_top_sellers": "Top 5 sellers (by revenue)",
    "ad.stat_top_products": "Top 5 products & services",
    "ad.stat_units_sold": "units sold",
    "ad.stat_no_data": "No data yet — first sales will show up here.",
    "ad.tab_users": "Users",
    "ad.tab_kyc": "KYC",
    "ad.tab_payouts": "Payouts",
    "ad.tab_categories": "Categories",
    "ad.tab_orders": "Orders",
    "ad.tab_currency": "Currencies",
    "ad.tab_banks": "Accounts",
    "ad.tab_company": "Company",
    "ad.tab_coupons": "Coupons",
    "ad.tab_platform": "Platform",
    "ad.tab_waitlist_fr": "FR Waitlist",
    "ad.tab_refunds": "Refunds",
    "ad.refunds_title": "Refund requests",
    "ad.refunds_intro": "Approve or reject refund requests from buyers. Approving a PawaPay refund automatically calls the PawaPay API. Bank transfers require you to send the counter-transfer manually after approval.",
    "ad.refunds_empty": "No pending requests. Well done — your customers are happy ✨",
    "ad.refunds_count": "pending request(s)",
    "ad.refunds_col_date": "Date",
    "ad.refunds_col_order": "Order",
    "ad.refunds_col_buyer": "Buyer",
    "ad.refunds_col_amount": "Amount",
    "ad.refunds_col_provider": "Payment",
    "ad.refunds_col_reason": "Reason",
    "ad.refunds_col_action": "Action",
    "ad.refunds_approve": "Approve",
    "ad.refunds_reject": "Reject",
    "ad.refunds_amount_optional": "Refund amount (optional — defaults to total)",
    "ad.refunds_reject_reason": "Rejection reason (mandatory)",
    "ad.refunds_reject_ph": "Explain why the request is denied — the buyer will receive this text by email.",
    "ad.refunds_confirm_approve": "Approve this refund? A PawaPay refund will be executed automatically.",
    "ad.refunds_confirm_reject": "Reject this refund request?",
    "ad.refunds_approved_toast": "Refund approved and executed",
    "ad.refunds_rejected_toast": "Request rejected — buyer notified",
    "ad.refunds_reason_defective": "Defective product",
    "ad.refunds_reason_not_as_described": "Not as described",
    "ad.refunds_reason_not_delivered": "Not delivered",
    "ad.refunds_reason_missing_item": "Missing item",
    "ad.refunds_reason_other": "Other",
    "ad.refunds_view_details": "View details",
    "ad.refunds_buyer_payout": "Buyer payout details",
    "ad.refunds_close": "Close",
    "ad.refunds_retry_title": "⚠️ Previous attempt failed",
    "ad.refunds_retry_pp_reason": "PawaPay reason",
    "ad.refunds_retry_hint": "Top up your PawaPay wallet first, then click Approve again to retry.",
    "ad.wl_title": "France leads — waiting list",
    "ad.wl_intro": "French merchants who asked to be notified when the Starter / Business / Premium plans go live (fiscal & legal review in progress). Export the list to prepare your commercial launch.",
    "ad.wl_leads_count": "lead(s) registered",
    "ad.wl_export": "Export as CSV",
    "ad.wl_exported": "leads exported to CSV",
    "ad.wl_empty": "No leads yet. The waitlist form is available on the 'Become a seller' page (France section).",
    "ad.wl_col_date": "Date",
    "ad.wl_col_email": "Email",
    "ad.wl_col_name": "First / Last name",
    "ad.wl_col_company": "Shop",
    "ad.wl_col_plan": "Plan",
    "ad.wl_col_note": "Message",
    "ad.confirm_delete": "Delete?",
    "ad.deleted": "Deleted",
    "ad.cat_name": "Name",
    "ad.cat_slug": "Slug",
    "ad.cat_type": "Type",
    "ad.cat_add": "Add",
    "ad.cat_product": "Product",
    "ad.cat_service": "Service",
    "ad.cat_both": "Mixed",
    "ad.cat_created": "Created",
    "ad.rates_title": "Exchange rates",
    "ad.rates_base": "Pivot currency:",
    "ad.rates_save": "Save rates",
    "ad.rates_saved": "Rates updated",
    "ad.rates_hint": "These rates are used as an approximation for the display of prices to buyers. Reference prices are expressed in EUR (pivot currency).",
    "ad.banks_title": "Bank accounts",
    "ad.banks_hint": "These details are shown to buyers who choose bank transfer.",
    "ad.banks_add": "Add an account",
    "ad.banks_bank": "Bank",
    "ad.banks_holder": "Holder",
    "ad.banks_number": "Account no.",
    "ad.banks_iban": "IBAN (optional)",
    "ad.banks_swift": "SWIFT / BIC",
    "ad.banks_currency": "Currency",
    "ad.banks_country": "Country",
    "ad.banks_notes": "Notes",
    "ad.banks_remove": "Remove",
    "ad.banks_save": "Save",
    "ad.banks_saved": "Bank accounts updated",
    "ad.banks_empty": "No account. Click \"Add an account\" to start.",
    "ad.co_title": "Company information",
    "ad.co_hint": "This info appears on the footer, legal notice, invoices and bank transfer page.",
    "ad.co_name": "Company name",
    "ad.co_form": "Legal form",
    "ad.co_rccm": "RCCM",
    "ad.co_tax": "Tax ID / National ID",
    "ad.co_manager": "Manager",
    "ad.co_address": "Head office address",
    "ad.co_phone": "Phone",
    "ad.co_email": "Official email",
    "ad.co_web": "Website",
    "ad.co_save": "Save",
    "ad.co_saved": "Company updated",
    "ad.cp_new": "New coupon",
    "ad.cp_code": "Code",
    "ad.cp_type": "Type",
    "ad.cp_pct": "% Percentage",
    "ad.cp_fixed": "€ Fixed amount",
    "ad.cp_value_pct": "Value (%)",
    "ad.cp_value_eur": "Value (EUR)",
    "ad.cp_min": "Minimum amount (EUR)",
    "ad.cp_max": "Max uses",
    "ad.cp_unlimited": "Unlimited",
    "ad.cp_valid": "Valid until",
    "ad.cp_desc": "Description (internal)",
    "ad.cp_desc_ph": "e.g. Welcome new customers",
    "ad.cp_create": "Create coupon",
    "ad.cp_list": "Existing coupons",
    "ad.cp_empty": "No coupon yet. Create one with the form on the left.",
    "ad.cp_min_short": "Min:",
    "ad.cp_uses": "use(s)",
    "ad.cp_inactive": "INACTIVE",
    "ad.cp_expires": "Expires on",
    "ad.cp_activate": "Activate",
    "ad.cp_deactivate": "Deactivate",
    "ad.cp_confirm_delete": "Delete this coupon?",
    "ad.cp_deleted": "Coupon deleted",
    "ad.cp_created": "created",
    "ad.cp_activated": "Coupon activated",
    "ad.cp_deactivated": "Coupon deactivated",
    "ad.kyc_queue": "Queue",
    "ad.kyc_all": "All",
    "ad.kyc_none": "No pending request 🎉",
    "ad.kyc_statuses": "Statuses",
    "ad.kyc_pending_badge": "PENDING",
    "ad.kyc_select_hint": "Select a seller on the left to see their documents.",
    "ad.kyc_status": "Status:",
    "ad.kyc_type": "Type",
    "ad.kyc_type_biz": "Business",
    "ad.kyc_type_ind": "Individual",
    "ad.kyc_legal_name": "Legal name",
    "ad.kyc_birth": "Birth",
    "ad.kyc_phone": "Phone",
    "ad.kyc_address": "Address",
    "ad.kyc_biz_name": "Business name",
    "ad.kyc_rccm": "RCCM",
    "ad.kyc_nif": "NIF",
    "ad.kyc_idnum": "ID document no.",
    "ad.kyc_payout": "Payout account",
    "ad.kyc_id_doc": "ID document",
    "ad.kyc_selfie": "Selfie",
    "ad.kyc_proof": "Proof",
    "ad.kyc_reason_ph": "Reason (required to reject or suspend)",
    "ad.kyc_reason_required": "Reason required",
    "ad.kyc_approve": "Approve",
    "ad.kyc_reject": "Reject",
    "ad.kyc_suspend": "Suspend",
    "ad.kyc_no_docs": "This seller hasn't submitted KYC documents yet.",
    "ad.kyc_approved": "Seller verified ✓",
    "ad.kyc_rejected": "Rejected",
    "ad.kyc_suspended": "Suspended",
    "ad.payouts_hint": "Orders whose retention has passed and must be paid out to sellers.",
    "ad.payouts_none": "No pending payout. All up to date ✓",
    "ad.payouts_paid_on": "Paid on",
    "ad.payouts_total_order": "Order total",
    "ad.payouts_sale": "Sale",
    "ad.payouts_commission": "Commission",
    "ad.payouts_confirm": "Mark this order as released to the seller?",
    "ad.payouts_mark": "Mark as released",
    "ad.payouts_pay_pawapay": "Pay via Mobile Money (PawaPay)",
    "ad.payouts_pawapay_confirm": "Automatically send the payment to the seller's Mobile Money number via PawaPay (Sandbox)?",
    "ad.payouts_pawapay_sent": "✅ Payout sent to seller via PawaPay",
    "ad.payouts_pawapay_partial": "Partial payout — some transfers failed",
    "ad.payouts_recorded": "Payout recorded",
    "ad.pl_title": "Marketplace settings",
    "ad.pl_intro": "SUKANACOOP commission, retention period, unverified seller cap.",
    "ad.pl_commission": "SUKANACOOP commission rate",
    "ad.pl_commission_hint": "(recommended 10-15%)",
    "ad.pl_retention": "Retention before payout",
    "ad.pl_retention_hint": "day(s) after payment (recommended 3-7)",
    "ad.pl_maxprod": "Unverified seller listings cap",
    "ad.pl_maxprod_hint": "max listings while non-KYC",
    "ad.pl_save": "Save",
    "ad.pl_saved": "Settings saved",
  },
};

const LangContext = createContext(null);

// Category translations by slug (stable identifier). Falls back to `name` if slug not mapped.
const CATEGORY_NAMES = {
  fr: {
    "electronique": "Électronique",
    "mode-beaute": "Mode & Beauté",
    "maison-mobilier": "Maison & Mobilier",
    "auto-moto": "Automobile & Moto",
    "immobilier": "Immobilier",
    "agriculture": "Agriculture",
    "animaux": "Animaux",
    "sport-loisirs": "Sport & Loisirs",
    "livres-formation": "Livres & Formation",
    "alimentation": "Alimentation",
    "sante-bebe": "Santé & Bébé",
    "plomberie": "Plomberie",
    "electricite": "Électricité",
    "informatique": "Informatique",
    "graphisme": "Graphisme",
    "traduction": "Traduction",
    "transport-livraison": "Transport & Livraison",
    "menage": "Ménage",
    "coiffure": "Coiffure",
    "sante-service": "Santé",
    "consulting": "Consulting",
    "reparation": "Réparation",
    "evenementiel": "Évènementiel",
    "soins-beaute": "Soins & Beauté",
    "artistique": "Artistique",
  },
  en: {
    "electronique": "Electronics",
    "mode-beaute": "Fashion & Beauty",
    "maison-mobilier": "Home & Furniture",
    "auto-moto": "Cars & Motorbikes",
    "immobilier": "Real estate",
    "agriculture": "Agriculture",
    "animaux": "Pets",
    "sport-loisirs": "Sports & Leisure",
    "livres-formation": "Books & Training",
    "alimentation": "Food",
    "sante-bebe": "Health & Baby",
    "plomberie": "Plumbing",
    "electricite": "Electrical",
    "informatique": "IT / Computing",
    "graphisme": "Graphic design",
    "traduction": "Translation",
    "transport-livraison": "Transport & Delivery",
    "menage": "Cleaning",
    "coiffure": "Hairdressing",
    "sante-service": "Health",
    "consulting": "Consulting",
    "reparation": "Repair",
    "evenementiel": "Events",
    "soins-beaute": "Beauty & Care",
    "artistique": "Arts & Crafts",
  },
};

export function LanguageProvider({ children }) {
  const [lang, setLangState] = useState(() => localStorage.getItem("sukana_lang") || "fr");

  useEffect(() => {
    localStorage.setItem("sukana_lang", lang);
    document.documentElement.lang = lang;
  }, [lang]);

  const setLang = (l) => setLangState(l);

  const t = (key) => dict[lang]?.[key] ?? dict.fr?.[key] ?? key;

  // Translate a category object by slug (falls back to name for admin-created custom categories)
  const tCategory = (cat) => {
    if (!cat) return "";
    const slug = cat.slug || "";
    return CATEGORY_NAMES[lang]?.[slug] ?? cat.name ?? "";
  };

  return (
    <LangContext.Provider value={{ lang, setLang, t, tCategory }}>
      {children}
    </LangContext.Provider>
  );
}

export const useLang = () => useContext(LangContext);

export const LANGUAGES = [
  { code: "fr", name: "Français", flag: "🇫🇷" },
  { code: "en", name: "English", flag: "🇬🇧" },
];
